export default {
    zh: {
        title: 'WeryAI 可接受使用政策',
        introTitle: '引言',
        intro: [
            '本可接受使用政策（以下简称“本政策”）是《WeryAI服务协议》（以下简称“主协议”）的组成部分，您（以下简称“用户”或“您”）通过访问或使用WeryAI提供的任何服务（包括但不限于网页端、移动应用程序及相关人工智能内容生成功能，以下统称“本服务”），即表示您同意遵守本政策中的所有条款。',
            '本政策旨在明确禁止利用本服务生成、上传、传播或存储任何违法违规、不当或损害他人合法权益的内容，特别是针对色情、裸露、性暗示及其他违反公序良俗或适用法律法规的行为。若您不接受本政策，请立即停止使用本服务。',
        ],
        sections: [
            {
                title: '1. 禁止的内容与行为',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '您在使用本服务过程中，不得单独或与他人共同从事以下任何行为，亦不得协助、鼓励、促使他人从事该等行为：',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 色情、裸露与性暗示内容',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '我们严格禁止将本服务用于任何与色情、淫秽、裸露或性暗示相关的用途，包括但不限于：',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1）生成或传播色情内容：利用本服务生成、上传、分享、展示、传输任何包含或暗示性行为、性挑逗、性暗示、淫秽语言、色情描写、裸露性器官、色情动漫、色情音频、色情视频、色情文本创作等内容；',
                                    '2）色情交互与角色扮演：通过本服务进行色情聊天、色情角色扮演、性幻想描述、性邀请或任何形式的虚拟性行为交互；',
                                    '3）色情平台与资源引导：提供、发布、推广或引导访问任何色情网站、色情应用、色情资源链接、色情社交群组或其他成人内容平台；',
                                    '4）商业化色情用途：利用本服务进行色情内容的生产、交易、广告投放、引流或任何形式的商业性色情活动。',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 违法、侵权与危害性内容',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '您不得利用本服务生成、上传、存储或传播以下内容或从事相关行为：',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1）违反法律法规的内容：包括但不限于危害国家安全、颠覆国家政权、破坏国家统一、煽动民族仇恨、宣扬恐怖主义、极端主义、分裂主义的内容；',
                                    '2）侵犯他人合法权益的内容：包括但不限于未经授权使用他人享有著作权、商标权、专利权等知识产权的素材，或侵犯他人肖像权、隐私权、名誉权、姓名权、商业秘密等权利的内容；',
                                    '3）暴力、仇恨、歧视内容：针对种族、民族、宗教信仰、性别、性取向、年龄、身体或精神状况、国籍、地域等群体或个人进行攻击、侮辱、威胁、骚扰、歧视或煽动暴力的内容；',
                                    '4）虚假、欺诈、误导性内容：包括但不限于制造虚假新闻、伪造身份、实施诈骗、钓鱼攻击、发布虚假广告或误导性商业信息；',
                                    '5）技术滥用行为：包括但不限于上传病毒、恶意代码、木马程序、使用爬虫或机器人批量访问本服务、利用技术漏洞绕过服务限制、进行拒绝服务攻击或其他破坏本服务正常运行的行为。',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. 您对输入内容与生成内容的全部责任',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '您理解并同意，您向本服务提供的所有输入内容（包括但不限于文本指令、参数设置、参考案例、上传的图片、视频、音频、设计模板等）必须合法、合规且不侵犯任何第三方权利。您保证对该等内容享有完整、无瑕疵的知识产权或已获得合法授权。',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '本服务根据您的输入生成相应内容（以下简称“生成内容”）。您对生成内容承担全部法律责任，包括但不限于内容合规性、知识产权侵权、人格权侵权、商业风险等。您应自行对生成内容进行必要的审查、评估及修改，确保其不违反本政策、主协议及任何适用法律法规。',
                            },
                        ],
                    },
                    {
                        title: '2.3 第三方平台发布责任',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '若您将生成内容发布至第三方平台（如社交媒体、广告系统、电商平台等），您必须遵守该平台的规则。因发布行为导致的任何处罚、损失或法律纠纷，均由您自行承担，与本平台无关。',
                            },
                        ],
                    },
                    {
                        title: '2.4 特别提醒',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'AI生成内容可能受到训练数据、算法逻辑等技术限制，不保证绝对准确、无害或符合特定法律要求。您不得以“AI生成”为由主张免除自身法律责任。',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. 我们的监督与执行权利',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '我们有权（但无义务）对您使用本服务的行为及生成内容进行监督、审查或抽查。如我们发现或收到合理举报，认为您或任何通过您账户使用本服务的人员违反了本政策，我们可以自行决定采取以下一项或多项措施，而无需提前通知：',
                    },
                    {
                        type: 'list',
                        items: [
                            '1）向您发出书面警告，要求限期整改；',
                            '2）删除、屏蔽或禁止访问违规内容；',
                            '3）暂停或终止您的全部或部分服务访问权限；',
                            '4）永久关闭您的账户，并禁止您重新注册；',
                            '5）向相关执法机关、监管机构或权利人报告或披露您的账户信息及使用记录；',
                            '6）依法追究您的违约或侵权责任，包括但不限于要求您赔偿我们及/或第三方因此遭受的全部损失（包括但不限于诉讼费、律师费、赔偿金等）。',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '上述措施不影响我们依据主协议或其他相关协议主张任何其他权利。',
                    },
                ],
            },
            {
                title: '4. 举报与投诉渠道',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '如果您在使用本服务过程中发现任何用户或任何内容可能违反本政策（例如发现色情内容、侵权内容或其他违规行为），我们鼓励您通过以下方式向我们举报或投诉：',
                    },
                    {
                        type: 'list',
                        items: [
                            '1）电子邮件：{email}',
                            '2）在线客服：登录您的WeryAI账户，进入账单页面或帮助中心，点击客服功能按钮并提交相关信息',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '我们将在合理期限内对举报内容进行审查，并根据本政策及适用法律法规采取相应措施。请注意，我们可能无法对每一份举报作出个别回复，但我们承诺会严肃对待每一条有效举报。',
                    },
                ],
            },
            {
                title: '5. 本政策的更新与修改',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '我们可根据业务发展、技术变化、法律法规要求或行业最佳实践的变化，不时对本政策进行修订或更新。更新后的政策将通过以下一种或多种方式通知您：',
                    },
                    {
                        type: 'list',
                        items: [
                            '1）在WeryAI官方网站（https://weryai.com）发布公告；',
                            '2）通过您注册邮箱发送通知；',
                            '3）通过站内消息或弹窗提示等方式告知。',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '修订后的政策自公告中载明的生效日期起生效。若您继续使用本服务，即表示您接受并同意遵守更新后的政策；如您不接受更新，请停止使用本服务。',
                    },
                ],
            },
        ],
        seoDescription:
            'WeryAI 可接受使用政策，说明平台禁止的内容与行为、用户责任、监督执行、举报投诉以及政策更新规则。',
    },
    en: {
        title: 'WeryAI Acceptable Use Policy',
        introTitle: 'Introduction',
        intro: [
            'This Acceptable Use Policy (hereinafter referred to as "this Policy") is an integral part of the WeryAI Service Agreement (hereinafter referred to as the "Master Agreement"). By accessing or using any services provided by WeryAI (including but not limited to the web version, mobile applications, and related AI content generation features, collectively referred to as the "Services"), you (hereinafter referred to as the "User" or "you") agree to comply with all terms of this Policy.',
            'This Policy is intended to clearly prohibit the use of the Services to generate, upload, disseminate, or store any illegal, improper, or rights-infringing content, especially pornography, nudity, sexual suggestiveness, and other conduct that violates public order, morality, or applicable laws and regulations. If you do not accept this Policy, please stop using the Services immediately.',
        ],
        sections: [
            {
                title: '1. Prohibited Content and Conduct',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'In the course of using the Services, you shall not, either alone or jointly with others, engage in any of the following acts, nor shall you assist, encourage, or induce others to engage in such acts:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Pornographic, Nude, and Sexually Suggestive Content',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'We strictly prohibit the use of the Services for any purpose related to pornography, obscenity, nudity, or sexual suggestiveness, including but not limited to:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Generating or disseminating pornographic content: Using the Services to generate, upload, share, display, or transmit any content containing or implying sexual acts, sexual teasing, sexual suggestiveness, obscene language, pornographic descriptions, exposed sexual organs, pornographic animation, pornographic audio, pornographic video, pornographic text creation, or similar content;',
                                    '2) Pornographic interaction and role-play: Conducting pornographic chats, pornographic role-play, sexual fantasy descriptions, sexual invitations, or any form of virtual sexual interaction through the Services;',
                                    '3) Guidance to pornographic platforms and resources: Providing, publishing, promoting, or guiding access to any pornographic websites, pornographic applications, pornographic resource links, pornographic social groups, or other adult content platforms;',
                                    '4) Commercialized pornographic use: Using the Services for the production, trading, advertising, traffic diversion, or any form of commercial pornographic activity.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Illegal, Infringing, and Harmful Content',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'You shall not use the Services to generate, upload, store, or disseminate the following content or engage in related conduct:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Content that violates laws and regulations: Including but not limited to content endangering national security, subverting state power, undermining national unity, inciting ethnic hatred, advocating terrorism, extremism, or separatism;',
                                    '2) Content that infringes upon the lawful rights and interests of others: Including but not limited to the unauthorized use of materials protected by others’ copyrights, trademark rights, patent rights, or other intellectual property rights, or content that infringes upon others’ portrait rights, privacy rights, reputation rights, name rights, trade secrets, or other rights;',
                                    '3) Violent, hateful, or discriminatory content: Content that attacks, insults, threatens, harasses, discriminates against, or incites violence against groups or individuals based on race, ethnicity, religion, gender, sexual orientation, age, physical or mental condition, nationality, region, or other characteristics;',
                                    '4) False, fraudulent, or misleading content: Including but not limited to creating fake news, forging identities, carrying out fraud, phishing attacks, publishing false advertisements, or misleading commercial information;',
                                    '5) Technical abuse: Including but not limited to uploading viruses, malicious code, Trojan programs, using crawlers or bots to access the Services in bulk, exploiting technical loopholes to bypass service restrictions, carrying out denial-of-service attacks, or otherwise disrupting the normal operation of the Services.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Your Full Responsibility for Input Content and Generated Content',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'You understand and agree that all input content you provide to the Services (including but not limited to text prompts, parameter settings, reference cases, uploaded images, videos, audio, design templates, etc.) must be lawful, compliant, and must not infringe upon any third-party rights. You warrant that you hold complete and unencumbered intellectual property rights in such content or have obtained lawful authorization.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'The Services generate corresponding content based on your input (hereinafter referred to as "Generated Content"). You bear full legal responsibility for Generated Content, including but not limited to content compliance, intellectual property infringement, personality rights infringement, and commercial risks. You shall independently review, evaluate, and modify Generated Content as necessary to ensure that it does not violate this Policy, the Master Agreement, or any applicable laws and regulations.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Responsibility for Publishing on Third-Party Platforms',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'If you publish Generated Content on third-party platforms (such as social media, advertising systems, e-commerce platforms, etc.), you must comply with the rules of those platforms. Any penalties, losses, or legal disputes arising from such publication shall be borne solely by you and shall have nothing to do with this platform.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Special Reminder',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'AI-generated content may be subject to technical limitations such as training data and algorithmic logic, and is not guaranteed to be absolutely accurate, harmless, or compliant with specific legal requirements. You may not claim exemption from your own legal responsibility on the grounds that the content was "AI-generated."',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Our Rights of Supervision and Enforcement',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'We have the right (but not the obligation) to supervise, review, or inspect your use of the Services and the Generated Content. If we discover or receive a reasonable report that you, or any person using the Services through your account, have violated this Policy, we may, at our sole discretion, take one or more of the following measures without prior notice:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Issue you a written warning and require rectification within a specified time limit;',
                            '2) Delete, block, or prohibit access to violating content;',
                            '3) Suspend or terminate all or part of your access to the Services;',
                            '4) Permanently close your account and prohibit you from re-registering;',
                            '5) Report or disclose your account information and usage records to relevant law enforcement authorities, regulatory bodies, or rights holders;',
                            '6) Pursue your liability for breach of contract or infringement in accordance with the law, including but not limited to requiring you to compensate us and/or third parties for all losses thereby suffered (including but not limited to litigation costs, attorneys’ fees, damages, etc.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'The above measures shall not affect any other rights we may claim under the Master Agreement or other related agreements.',
                    },
                ],
            },
            {
                title: '4. Reporting and Complaint Channels',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'If, during your use of the Services, you discover that any user or any content may violate this Policy (for example, pornographic content, infringing content, or other violations), we encourage you to report or complain to us through the following methods:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Email: {email}',
                            '2) Online customer service: Log in to your WeryAI account, go to the billing page or help center, click the customer service function button, and submit the relevant information',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'We will review reported content within a reasonable period and take corresponding measures in accordance with this Policy and applicable laws and regulations. Please note that we may not be able to provide an individual response to every report, but we undertake to treat every valid report seriously.',
                    },
                ],
            },
            {
                title: '5. Updates and Revisions to This Policy',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'We may revise or update this Policy from time to time based on business development, technological changes, legal and regulatory requirements, or changes in industry best practices. The updated Policy will be notified to you through one or more of the following methods:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Posting an announcement on the WeryAI official website (https://weryai.com);',
                            '2) Sending a notice to your registered email address;',
                            '3) Informing you through on-site messages, pop-up prompts, or other means.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'The revised Policy shall take effect on the effective date stated in the announcement. If you continue to use the Services, it means that you accept and agree to comply with the updated Policy; if you do not accept the update, please stop using the Services.',
                    },
                ],
            },
        ],
        seoDescription:
            'WeryAI Acceptable Use Policy describing prohibited content and conduct, user responsibility, supervision and enforcement, reporting channels, and policy updates.',
    },
    ja: {
        title: 'WeryAI 適正利用ポリシー',
        introTitle: 'はじめに',
        intro: [
            '本適正利用ポリシー（以下「本ポリシー」）は、「WeryAIサービス契約」（以下「主契約」）の一部を構成するものです。お客様（以下「ユーザー」または「お客様」）が、WeryAIが提供するいずれかのサービス（Web版、モバイルアプリ、および関連するAIコンテンツ生成機能を含みますが、これらに限定されません。以下総称して「本サービス」）にアクセスまたは利用することにより、本ポリシーのすべての条項に従うことに同意したものとみなされます。',
            '本ポリシーは、本サービスを利用して、違法、不適切、または他者の正当な権利利益を侵害するコンテンツを生成、アップロード、配布、または保存することを明確に禁止することを目的としています。特に、ポルノ、裸露、性的示唆、および公序良俗または適用される法令に違反するその他の行為を対象とします。本ポリシーに同意できない場合は、直ちに本サービスの利用を中止してください。',
        ],
        sections: [
            {
                title: '1. 禁止されるコンテンツおよび行為',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '本サービスの利用にあたり、お客様は単独または他者と共同して、以下のいずれの行為も行ってはならず、また他者が当該行為を行うことを支援、奨励、または促進してはなりません。',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 ポルノ、裸露、および性的示唆を含むコンテンツ',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '当社は、本サービスをポルノ、わいせつ、裸露、または性的示唆に関連するいかなる目的にも使用することを厳格に禁止します。これには以下を含みますが、これらに限定されません。',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1）ポルノコンテンツの生成または拡散：本サービスを利用して、性的行為、性的挑発、性的示唆、わいせつな言葉、ポルノ描写、性器の露出、ポルノアニメ、ポルノ音声、ポルノ動画、ポルノ文章の創作などを含む、または示唆するコンテンツを生成、アップロード、共有、表示、または送信すること。',
                                    '2）ポルノ的な交流およびロールプレイ：本サービスを通じて、ポルノチャット、ポルノ的ロールプレイ、性的幻想の描写、性的誘い、またはあらゆる形態の仮想的な性的行為のやり取りを行うこと。',
                                    '3）ポルノプラットフォームおよびリソースへの誘導：ポルノサイト、ポルノアプリ、ポルノリソースリンク、ポルノソーシャルグループ、またはその他の成人向けコンテンツプラットフォームへのアクセスを提供、公開、宣伝、または誘導すること。',
                                    '4）商業的なポルノ利用：本サービスを利用して、ポルノコンテンツの制作、取引、広告掲載、流入誘導、またはその他あらゆる形態の商業的ポルノ活動を行うこと。',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 違法、権利侵害、および有害なコンテンツ',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'お客様は、本サービスを利用して以下のコンテンツを生成、アップロード、保存、または拡散してはならず、また関連する行為を行ってはなりません。',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1）法令に違反するコンテンツ：国家安全保障を危うくする内容、国家権力の転覆、国家統一の破壊、民族憎悪の扇動、テロリズム、過激主義、分離主義の宣伝を含みますが、これらに限定されません。',
                                    '2）他者の正当な権利利益を侵害するコンテンツ：他者の著作権、商標権、特許権などの知的財産権により保護された素材の無断使用、または肖像権、プライバシー権、名誉権、氏名権、営業秘密その他の権利を侵害するコンテンツを含みますが、これらに限定されません。',
                                    '3）暴力、憎悪、差別的コンテンツ：人種、民族、宗教、性別、性的指向、年齢、身体的または精神的状態、国籍、地域などに基づき、個人または集団を攻撃、侮辱、脅迫、嫌がらせ、差別、または暴力を扇動するコンテンツ。',
                                    '4）虚偽、詐欺的、または誤解を招くコンテンツ：フェイクニュースの作成、身元の偽装、詐欺の実施、フィッシング攻撃、虚偽広告または誤解を招く商業情報の公開を含みますが、これらに限定されません。',
                                    '5）技術的な悪用行為：ウイルス、悪意のあるコード、トロイの木馬のアップロード、クローラーやボットによる本サービスへの大量アクセス、技術的な脆弱性を利用した制限回避、サービス拒否攻撃、または本サービスの正常な運営を妨害するその他の行為を含みますが、これらに限定されません。',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. 入力コンテンツおよび生成コンテンツに関するお客様の全面的な責任',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'お客様は、本サービスに提供するすべての入力コンテンツ（テキスト指示、パラメータ設定、参考事例、アップロードした画像、動画、音声、デザインテンプレートなどを含みますが、これらに限定されません）が、合法かつ適法であり、第三者の権利を侵害しないものでなければならないことを理解し、これに同意するものとします。お客様は、当該コンテンツについて完全かつ瑕疵のない知的財産権を有しているか、または適法な許諾を取得していることを保証します。',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '本サービスは、お客様の入力に基づいて対応するコンテンツ（以下「生成コンテンツ」）を生成します。お客様は、コンテンツの適法性、知的財産権侵害、人格権侵害、商業上のリスクなどを含みますが、これらに限定されない、生成コンテンツに関するすべての法的責任を負います。お客様は、生成コンテンツが本ポリシー、主契約、および適用される法令に違反しないことを確保するため、必要な確認、評価、および修正を自ら行うものとします。',
                            },
                        ],
                    },
                    {
                        title: '2.3 第三者プラットフォームへの公開責任',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'お客様が生成コンテンツを第三者プラットフォーム（ソーシャルメディア、広告システム、ECプラットフォームなど）に公開する場合、お客様は当該プラットフォームの規則を遵守しなければなりません。公開行為により生じたあらゆる処分、損失、または法的紛争は、すべてお客様自身の責任とし、本プラットフォームとは一切関係ありません。',
                            },
                        ],
                    },
                    {
                        title: '2.4 特別な注意',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'AI生成コンテンツは、学習データやアルゴリズムロジックなどの技術的制約を受ける可能性があり、絶対的な正確性、無害性、または特定の法的要件への適合性を保証するものではありません。お客様は、「AIが生成した」ことを理由に自らの法的責任の免除を主張することはできません。',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. 当社の監督および執行の権利',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '当社は、お客様による本サービスの利用行為および生成コンテンツを監督、審査、または抜き取り確認する権利（ただし義務ではありません）を有します。当社が、お客様またはお客様のアカウントを通じて本サービスを利用する者が本ポリシーに違反したと判断した場合、または合理的な通報を受けた場合、当社は事前通知なく、自己の裁量により以下の一つまたは複数の措置を講じることができます。',
                    },
                    {
                        type: 'list',
                        items: [
                            '1）書面による警告を発し、期限内の是正を要求すること。',
                            '2）違反コンテンツを削除、遮断、またはアクセス禁止にすること。',
                            '3）お客様の本サービスへのアクセス権の全部または一部を停止または終了すること。',
                            '4）お客様のアカウントを永久に閉鎖し、再登録を禁止すること。',
                            '5）関連する法執行機関、規制当局、または権利者に対し、お客様のアカウント情報および利用記録を報告または開示すること。',
                            '6）法令に基づき、お客様の契約違反または権利侵害責任を追及すること。これには、当社および／または第三者が被ったすべての損失（訴訟費用、弁護士費用、賠償金などを含みますが、これらに限定されません）の賠償請求が含まれます。',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '上記措置は、当社が主契約またはその他関連契約に基づいて主張し得るその他の権利に影響を与えるものではありません。',
                    },
                ],
            },
            {
                title: '4. 通報および苦情窓口',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '本サービスの利用中に、いずれかのユーザーまたはコンテンツが本ポリシーに違反している可能性があることを発見した場合（ポルノコンテンツ、権利侵害コンテンツ、その他の違反行為など）、当社は以下の方法で通報または苦情を提出することを推奨します。',
                    },
                    {
                        type: 'list',
                        items: [
                            '1）電子メール：{email}',
                            '2）オンラインカスタマーサービス：WeryAIアカウントにログインし、請求ページまたはヘルプセンターに入り、カスタマーサービス機能ボタンをクリックして関連情報を送信してください。',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '当社は、合理的な期間内に通報内容を審査し、本ポリシーおよび適用法令に従って適切な措置を講じます。なお、すべての通報に個別回答できるとは限りませんが、有効な通報一つひとつを真摯に取り扱うことをお約束します。',
                    },
                ],
            },
            {
                title: '5. 本ポリシーの更新および変更',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '当社は、事業の発展、技術の変化、法令上の要請、または業界のベストプラクティスの変化に応じて、本ポリシーを随時改訂または更新することがあります。更新後のポリシーは、以下の一つまたは複数の方法でお客様に通知されます。',
                    },
                    {
                        type: 'list',
                        items: [
                            '1）WeryAI公式ウェブサイト（https://weryai.com）で公告を掲載すること。',
                            '2）登録メールアドレス宛てに通知を送信すること。',
                            '3）サイト内メッセージやポップアップなどにより通知すること。',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '改訂後のポリシーは、公告に記載された施行日から効力を生じます。お客様が引き続き本サービスを利用した場合、更新後のポリシーを受諾し、これを遵守することに同意したものとみなされます。更新に同意しない場合は、本サービスの利用を中止してください。',
                    },
                ],
            },
        ],
        seoDescription:
            'WeryAIの適正利用ポリシー。禁止されるコンテンツと行為、ユーザー責任、監督と執行、通報窓口、ポリシー更新について説明します。',
    },
    ko: {
        title: 'WeryAI 허용 가능한 사용 정책',
        introTitle: '소개',
        intro: [
            '본 허용 가능한 사용 정책(이하 "본 정책")은 WeryAI 서비스 계약(이하 "주 계약")의 구성 부분입니다. 귀하(이하 "사용자" 또는 "귀하")가 WeryAI가 제공하는 모든 서비스(웹 버전, 모바일 애플리케이션 및 관련 AI 콘텐츠 생성 기능을 포함하되 이에 국한되지 않으며, 이하 총칭하여 "본 서비스")에 접근하거나 이를 사용하는 경우, 귀하는 본 정책의 모든 조항을 준수하는 데 동의한 것으로 간주됩니다.',
            '본 정책은 본 서비스를 이용하여 불법적이거나 부적절하거나 타인의 적법한 권익을 침해하는 콘텐츠를 생성, 업로드, 전파 또는 저장하는 행위를 명확히 금지하기 위한 것입니다. 특히 음란물, 노출, 성적 암시 및 공공질서, 선량한 풍속 또는 관련 법령을 위반하는 기타 행위를 대상으로 합니다. 본 정책에 동의하지 않는 경우 즉시 본 서비스의 사용을 중단해 주십시오.',
        ],
        sections: [
            {
                title: '1. 금지되는 콘텐츠 및 행위',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '귀하는 본 서비스를 사용하는 과정에서 단독으로 또는 타인과 공동으로 다음 각 호의 행위를 해서는 안 되며, 다른 사람이 그러한 행위를 하도록 돕거나, 장려하거나, 유도해서도 안 됩니다.',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 음란물, 노출 및 성적 암시 콘텐츠',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '당사는 본 서비스를 음란물, 외설, 노출 또는 성적 암시와 관련된 어떠한 목적으로 사용하는 것도 엄격히 금지합니다. 여기에는 다음이 포함되나 이에 국한되지 않습니다.',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) 음란 콘텐츠 생성 또는 유포: 본 서비스를 이용하여 성행위, 성적 유혹, 성적 암시, 외설적 언어, 음란 묘사, 성기의 노출, 음란 애니메이션, 음란 오디오, 음란 비디오, 음란 텍스트 창작 등을 포함하거나 암시하는 모든 콘텐츠를 생성, 업로드, 공유, 표시 또는 전송하는 행위.',
                                    '2) 음란적 상호작용 및 역할극: 본 서비스를 통해 음란 채팅, 음란 역할극, 성적 환상 묘사, 성적 초대 또는 어떤 형태의 가상 성행위 상호작용을 수행하는 행위.',
                                    '3) 음란 플랫폼 및 리소스 유도: 음란 웹사이트, 음란 애플리케이션, 음란 리소스 링크, 음란 소셜 그룹 또는 기타 성인 콘텐츠 플랫폼에 대한 접근을 제공, 게시, 홍보 또는 유도하는 행위.',
                                    '4) 상업적 음란 용도: 본 서비스를 이용하여 음란 콘텐츠의 제작, 거래, 광고 집행, 트래픽 유도 또는 어떤 형태의 상업적 음란 활동을 수행하는 행위.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 불법, 권리침해 및 유해 콘텐츠',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '귀하는 본 서비스를 이용하여 다음 콘텐츠를 생성, 업로드, 저장 또는 전파하거나 관련 행위를 해서는 안 됩니다.',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) 법률 및 규정을 위반하는 콘텐츠: 국가 안보를 해치는 내용, 국가 권력 전복, 국가 통일 훼손, 민족 증오 선동, 테러리즘, 극단주의, 분리주의 선전을 포함하되 이에 국한되지 않습니다.',
                                    '2) 타인의 적법한 권익을 침해하는 콘텐츠: 타인의 저작권, 상표권, 특허권 등 지식재산권이 있는 자료를 무단으로 사용하는 행위 또는 초상권, 프라이버시권, 명예권, 성명권, 영업비밀 등 기타 권리를 침해하는 콘텐츠를 포함하되 이에 국한되지 않습니다.',
                                    '3) 폭력, 혐오, 차별 콘텐츠: 인종, 민족, 종교, 성별, 성적 지향, 연령, 신체적 또는 정신적 상태, 국적, 지역 등을 이유로 특정 집단 또는 개인을 공격, 모욕, 위협, 괴롭힘, 차별하거나 폭력을 선동하는 콘텐츠.',
                                    '4) 허위, 사기 또는 오해의 소지가 있는 콘텐츠: 가짜 뉴스 제작, 신분 위조, 사기 실행, 피싱 공격, 허위 광고 또는 오해를 불러일으키는 상업 정보 게시를 포함하되 이에 국한되지 않습니다.',
                                    '5) 기술 남용 행위: 바이러스, 악성 코드, 트로이 목마 업로드, 크롤러나 봇을 사용한 대량 접근, 기술적 취약점을 이용한 서비스 제한 우회, 서비스 거부 공격 수행 또는 본 서비스의 정상적인 운영을 방해하는 기타 행위를 포함하되 이에 국한되지 않습니다.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. 입력 콘텐츠 및 생성 콘텐츠에 대한 귀하의 전적인 책임',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '귀하는 본 서비스에 제공하는 모든 입력 콘텐츠(텍스트 프롬프트, 매개변수 설정, 참고 사례, 업로드된 이미지, 비디오, 오디오, 디자인 템플릿 등을 포함하되 이에 국한되지 않음)가 합법적이고 규정을 준수하며 제3자의 권리를 침해하지 않아야 함을 이해하고 이에 동의합니다. 귀하는 해당 콘텐츠에 대해 완전하고 하자 없는 지식재산권을 보유하거나 적법한 허가를 받았음을 보증합니다.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '본 서비스는 귀하의 입력을 바탕으로 해당 콘텐츠(이하 "생성 콘텐츠")를 생성합니다. 귀하는 콘텐츠 적합성, 지식재산권 침해, 인격권 침해, 상업적 위험 등을 포함하되 이에 국한되지 않는 생성 콘텐츠에 대한 모든 법적 책임을 부담합니다. 귀하는 생성 콘텐츠가 본 정책, 주 계약 및 관련 법령을 위반하지 않도록 스스로 검토, 평가 및 수정해야 합니다.',
                            },
                        ],
                    },
                    {
                        title: '2.3 제3자 플랫폼 게시 책임',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '귀하가 생성 콘텐츠를 제3자 플랫폼(소셜 미디어, 광고 시스템, 전자상거래 플랫폼 등)에 게시하는 경우, 해당 플랫폼의 규칙을 준수해야 합니다. 게시 행위로 인해 발생하는 모든 제재, 손실 또는 법적 분쟁은 전적으로 귀하의 책임이며 본 플랫폼과는 무관합니다.',
                            },
                        ],
                    },
                    {
                        title: '2.4 특별 안내',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'AI 생성 콘텐츠는 학습 데이터, 알고리즘 로직 등의 기술적 한계의 영향을 받을 수 있으며, 절대적으로 정확하거나 무해하거나 특정 법적 요구사항에 부합함이 보장되지 않습니다. 귀하는 콘텐츠가 "AI 생성"되었다는 이유로 자신의 법적 책임 면제를 주장할 수 없습니다.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. 당사의 감독 및 집행 권한',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '당사는 귀하의 본 서비스 이용 행위 및 생성 콘텐츠를 감독, 심사 또는 표본 점검할 권리(의무는 아님)를 가집니다. 당사가 귀하 또는 귀하의 계정을 통해 본 서비스를 이용하는 사람이 본 정책을 위반했다고 판단하거나 합리적인 신고를 받은 경우, 당사는 사전 통지 없이 자체 재량으로 다음 중 하나 이상의 조치를 취할 수 있습니다.',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) 서면 경고를 발송하고 기한 내 시정을 요구하는 조치.',
                            '2) 위반 콘텐츠를 삭제, 차단 또는 접근 금지하는 조치.',
                            '3) 귀하의 서비스 접근 권한 전부 또는 일부를 일시 중지하거나 종료하는 조치.',
                            '4) 귀하의 계정을 영구적으로 폐쇄하고 재가입을 금지하는 조치.',
                            '5) 관련 법 집행기관, 규제기관 또는 권리자에게 귀하의 계정 정보 및 사용 기록을 보고하거나 공개하는 조치.',
                            '6) 법에 따라 귀하의 계약위반 또는 권리침해 책임을 추궁하는 조치. 여기에는 당사 및/또는 제3자가 입은 모든 손실(소송비, 변호사비, 손해배상금 등을 포함하되 이에 국한되지 않음)에 대한 배상 청구가 포함됩니다.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '위 조치는 당사가 주 계약 또는 기타 관련 계약에 따라 주장할 수 있는 다른 권리에 영향을 미치지 않습니다.',
                    },
                ],
            },
            {
                title: '4. 신고 및 불만 접수 채널',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '귀하가 본 서비스를 이용하는 과정에서 어떤 사용자 또는 콘텐츠가 본 정책을 위반할 수 있다고 발견한 경우(예: 음란 콘텐츠, 권리침해 콘텐츠 또는 기타 위반 행위), 당사는 다음 방법을 통해 신고 또는 불만을 제기할 것을 권장합니다.',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) 이메일: {email}',
                            '2) 온라인 고객센터: WeryAI 계정에 로그인한 후 청구 페이지 또는 도움말 센터로 이동하여 고객센터 기능 버튼을 클릭하고 관련 정보를 제출하십시오.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '당사는 합리적인 기간 내에 신고 내용을 검토하고 본 정책 및 관련 법령에 따라 적절한 조치를 취합니다. 모든 신고에 개별적으로 답변드릴 수는 없지만, 유효한 모든 신고를 성실하게 처리할 것을 약속드립니다.',
                    },
                ],
            },
            {
                title: '5. 본 정책의 업데이트 및 수정',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '당사는 사업 발전, 기술 변화, 법률 및 규제 요구사항 또는 업계 모범사례의 변화에 따라 본 정책을 수시로 개정하거나 업데이트할 수 있습니다. 업데이트된 정책은 다음 중 하나 이상의 방법으로 귀하에게 통지됩니다.',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) WeryAI 공식 웹사이트(https://weryai.com)에 공지 게시.',
                            '2) 귀하의 등록 이메일 주소로 통지 발송.',
                            '3) 사이트 내 메시지 또는 팝업 알림 등으로 안내.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '개정된 정책은 공지에 명시된 시행일부터 효력을 가집니다. 귀하가 본 서비스를 계속 사용하는 경우 업데이트된 정책을 수락하고 준수하는 데 동의한 것으로 간주됩니다. 업데이트를 수락하지 않는 경우 본 서비스 사용을 중단해 주십시오.',
                    },
                ],
            },
        ],
        seoDescription:
            'WeryAI 허용 가능한 사용 정책으로 금지된 콘텐츠와 행위, 사용자 책임, 감독 및 집행, 신고 채널, 정책 업데이트를 설명합니다.',
    },
    tw: {
        title: 'WeryAI 可接受使用政策',
        introTitle: '引言',
        intro: [
            '本可接受使用政策（以下簡稱「本政策」）是《WeryAI服務協議》（以下簡稱「主協議」）的組成部分，您（以下簡稱「用戶」或「您」）通過訪問或使用WeryAI提供的任何服務（包括但不限於網頁端、移動應用程式及相關人工智慧內容生成功能，以下統稱「本服務」），即表示您同意遵守本政策中的所有條款。',
            '本政策旨在明確禁止利用本服務生成、上傳、傳播或儲存任何違法違規、不當或損害他人合法權益的內容，特別是針對色情、裸露、性暗示及其他違反公序良俗或適用法律法規的行為。若您不接受本政策，請立即停止使用本服務。',
        ],
        sections: [
            {
                title: '1. 禁止的內容與行為',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '您在使用本服務過程中，不得單獨或與他人共同從事以下任何行為，亦不得協助、鼓勵、促使他人從事該等行為：',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 色情、裸露與性暗示內容',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '我們嚴格禁止將本服務用於任何與色情、淫穢、裸露或性暗示相關的用途，包括但不限於：',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1）生成或傳播色情內容：利用本服務生成、上傳、分享、展示、傳輸任何包含或暗示性行為、性挑逗、性暗示、淫穢語言、色情描寫、裸露性器官、色情動漫、色情音訊、色情影片、色情文本創作等內容；',
                                    '2）色情互動與角色扮演：通過本服務進行色情聊天、色情角色扮演、性幻想描述、性邀請或任何形式的虛擬性行為互動；',
                                    '3）色情平台與資源引導：提供、發布、推廣或引導訪問任何色情網站、色情應用、色情資源連結、色情社交群組或其他成人內容平台；',
                                    '4）商業化色情用途：利用本服務進行色情內容的生產、交易、廣告投放、引流或任何形式的商業性色情活動。',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 違法、侵權與危害性內容',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '您不得利用本服務生成、上傳、儲存或傳播以下內容或從事相關行為：',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1）違反法律法規的內容：包括但不限於危害國家安全、顛覆國家政權、破壞國家統一、煽動民族仇恨、宣揚恐怖主義、極端主義、分裂主義的內容；',
                                    '2）侵犯他人合法權益的內容：包括但不限於未經授權使用他人享有著作權、商標權、專利權等智慧財產權的素材，或侵犯他人肖像權、隱私權、名譽權、姓名權、商業秘密等權利的內容；',
                                    '3）暴力、仇恨、歧視內容：針對種族、民族、宗教信仰、性別、性取向、年齡、身體或精神狀況、國籍、地域等群體或個人進行攻擊、侮辱、威脅、騷擾、歧視或煽動暴力的內容；',
                                    '4）虛假、欺詐、誤導性內容：包括但不限於製造虛假新聞、偽造身份、實施詐騙、釣魚攻擊、發布虛假廣告或誤導性商業資訊；',
                                    '5）技術濫用行為：包括但不限於上傳病毒、惡意程式碼、木馬程式、使用爬蟲或機器人批量訪問本服務、利用技術漏洞繞過服務限制、進行拒絕服務攻擊或其他破壞本服務正常運行的行為。',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. 您對輸入內容與生成內容的全部責任',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '您理解並同意，您向本服務提供的所有輸入內容（包括但不限於文本指令、參數設定、參考案例、上傳的圖片、影片、音訊、設計範本等）必須合法、合規且不侵犯任何第三方權利。您保證對該等內容享有完整、無瑕疵的智慧財產權或已獲得合法授權。',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '本服務根據您的輸入生成相應內容（以下簡稱「生成內容」）。您對生成內容承擔全部法律責任，包括但不限於內容合規性、智慧財產權侵權、人格權侵權、商業風險等。您應自行對生成內容進行必要的審查、評估及修改，確保其不違反本政策、主協議及任何適用法律法規。',
                            },
                        ],
                    },
                    {
                        title: '2.3 第三方平台發布責任',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: '若您將生成內容發布至第三方平台（如社交媒體、廣告系統、電商平台等），您必須遵守該平台的規則。因發布行為導致的任何處罰、損失或法律糾紛，均由您自行承擔，與本平台無關。',
                            },
                        ],
                    },
                    {
                        title: '2.4 特別提醒',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'AI生成內容可能受到訓練資料、演算法邏輯等技術限制，不保證絕對準確、無害或符合特定法律要求。您不得以「AI生成」為由主張免除自身法律責任。',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. 我們的監督與執行權利',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '我們有權（但無義務）對您使用本服務的行為及生成內容進行監督、審查或抽查。如我們發現或收到合理舉報，認為您或任何通過您帳戶使用本服務的人員違反了本政策，我們可以自行決定採取以下一項或多項措施，而無需提前通知：',
                    },
                    {
                        type: 'list',
                        items: [
                            '1）向您發出書面警告，要求限期整改；',
                            '2）刪除、屏蔽或禁止訪問違規內容；',
                            '3）暫停或終止您的全部或部分服務訪問權限；',
                            '4）永久關閉您的帳戶，並禁止您重新註冊；',
                            '5）向相關執法機關、監管機構或權利人報告或披露您的帳戶資訊及使用記錄；',
                            '6）依法追究您的違約或侵權責任，包括但不限於要求您賠償我們及／或第三方因此遭受的全部損失（包括但不限於訴訟費、律師費、賠償金等）。',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '上述措施不影響我們依據主協議或其他相關協議主張任何其他權利。',
                    },
                ],
            },
            {
                title: '4. 舉報與投訴管道',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '如果您在使用本服務過程中發現任何用戶或任何內容可能違反本政策（例如發現色情內容、侵權內容或其他違規行為），我們鼓勵您通過以下方式向我們舉報或投訴：',
                    },
                    {
                        type: 'list',
                        items: [
                            '1）電子郵件：{email}',
                            '2）線上客服：登入您的WeryAI帳戶，進入帳單頁面或幫助中心，點擊客服功能按鈕並提交相關資訊',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '我們將在合理期限內對舉報內容進行審查，並根據本政策及適用法律法規採取相應措施。請注意，我們可能無法對每一份舉報作出個別回覆，但我們承諾會嚴肅對待每一條有效舉報。',
                    },
                ],
            },
            {
                title: '5. 本政策的更新與修改',
                blocks: [
                    {
                        type: 'paragraph',
                        text: '我們可根據業務發展、技術變化、法律法規要求或行業最佳實踐的變化，不時對本政策進行修訂或更新。更新後的政策將通過以下一種或多種方式通知您：',
                    },
                    {
                        type: 'list',
                        items: [
                            '1）在WeryAI官方網站（https://weryai.com）發布公告；',
                            '2）通過您註冊郵箱發送通知；',
                            '3）通過站內訊息或彈窗提示等方式告知。',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: '修訂後的政策自公告中載明的生效日期起生效。若您繼續使用本服務，即表示您接受並同意遵守更新後的政策；如您不接受更新，請停止使用本服務。',
                    },
                ],
            },
        ],
        seoDescription:
            'WeryAI 可接受使用政策，說明平台禁止的內容與行為、用戶責任、監督執行、舉報投訴以及政策更新規則。',
    },
    pl: {
        title: 'Polityka dopuszczalnego użytkowania WeryAI',
        introTitle: 'Wprowadzenie',
        intro: [
            'Niniejsza Polityka dopuszczalnego użytkowania (dalej „Niniejsza Polityka”) stanowi integralną część Umowy o świadczenie usług WeryAI (dalej „Umowa Główna”). Uzyskując dostęp do jakichkolwiek usług świadczonych przez WeryAI lub korzystając z nich (w tym między innymi z wersji internetowej, aplikacji mobilnych oraz powiązanych funkcji generowania treści przez sztuczną inteligencję, zwanych łącznie „Usługami”), użytkownik (dalej „Użytkownik” lub „Ty”) wyraża zgodę na przestrzeganie wszystkich postanowień Niniejszej Polityki.',
            'Celem Niniejszej Polityki jest jednoznaczne zakazanie wykorzystywania Usług do generowania, przesyłania, rozpowszechniania lub przechowywania jakichkolwiek treści niezgodnych z prawem, niewłaściwych lub naruszających uzasadnione prawa i interesy innych osób, w szczególności treści pornograficznych, nagości, sugestii seksualnych oraz innych zachowań naruszających porządek publiczny, dobre obyczaje lub obowiązujące przepisy prawa. Jeśli nie akceptujesz Niniejszej Polityki, natychmiast zaprzestań korzystania z Usług.',
        ],
        sections: [
            {
                title: '1. Zakazane treści i działania',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Podczas korzystania z Usług nie możesz samodzielnie ani wspólnie z innymi podejmować żadnych z poniższych działań, ani pomagać, zachęcać lub nakłaniać innych do ich podejmowania:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Treści pornograficzne, nagość i sugestie seksualne',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Surowo zakazujemy wykorzystywania Usług do jakichkolwiek celów związanych z pornografią, obscenicznością, nagością lub sugestiami seksualnymi, w tym między innymi do:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Generowania lub rozpowszechniania treści pornograficznych: wykorzystywania Usług do generowania, przesyłania, udostępniania, wyświetlania lub przekazywania jakichkolwiek treści zawierających lub sugerujących akty seksualne, seksualne prowokowanie, sugestie seksualne, obsceniczny język, opisy pornograficzne, odsłonięte narządy płciowe, pornograficzne animacje, pornograficzne audio, pornograficzne wideo, pornograficzne teksty lub podobne treści;',
                                    '2) Pornograficznych interakcji i odgrywania ról: prowadzenia przez Usługi pornograficznych czatów, pornograficznych odgrywań ról, opisów fantazji seksualnych, zaproszeń seksualnych lub jakiejkolwiek formy wirtualnej interakcji seksualnej;',
                                    '3) Kierowania do platform i zasobów pornograficznych: dostarczania, publikowania, promowania lub kierowania do jakichkolwiek stron pornograficznych, aplikacji pornograficznych, linków do zasobów pornograficznych, grup społecznościowych o charakterze pornograficznym lub innych platform z treściami dla dorosłych;',
                                    '4) Komercyjnego wykorzystywania pornografii: wykorzystywania Usług do produkcji, handlu, reklamy, pozyskiwania ruchu lub jakiejkolwiek formy komercyjnej działalności pornograficznej.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Treści nielegalne, naruszające prawa i szkodliwe',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Nie możesz wykorzystywać Usług do generowania, przesyłania, przechowywania lub rozpowszechniania następujących treści ani podejmować powiązanych działań:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Treści naruszających przepisy prawa: w tym między innymi treści zagrażających bezpieczeństwu państwa, obalających władzę państwową, podważających jedność państwa, podżegających do nienawiści etnicznej lub propagujących terroryzm, ekstremizm lub separatyzm;',
                                    '2) Treści naruszających uzasadnione prawa i interesy innych osób: w tym między innymi nieuprawnionego wykorzystywania materiałów chronionych prawami autorskimi, znakami towarowymi, patentami lub innymi prawami własności intelektualnej osób trzecich, bądź treści naruszających prawa do wizerunku, prywatności, dobrego imienia, nazwiska, tajemnicy handlowej lub inne prawa;',
                                    '3) Treści zawierających przemoc, nienawiść lub dyskryminację: treści atakujących, obrażających, grożących, nękających, dyskryminujących lub podżegających do przemocy wobec grup lub osób ze względu na rasę, pochodzenie etniczne, religię, płeć, orientację seksualną, wiek, stan fizyczny lub psychiczny, narodowość, region lub inne cechy;',
                                    '4) Treści fałszywych, oszukańczych lub wprowadzających w błąd: w tym między innymi tworzenia fałszywych wiadomości, podszywania się pod inne osoby, dokonywania oszustw, przeprowadzania ataków phishingowych, publikowania fałszywych reklam lub wprowadzających w błąd informacji handlowych;',
                                    '5) Nadużyć technicznych: w tym między innymi przesyłania wirusów, złośliwego kodu, trojanów, używania crawlerów lub botów do masowego dostępu do Usług, wykorzystywania luk technicznych do obchodzenia ograniczeń usługi, przeprowadzania ataków odmowy usługi lub innych działań zakłócających prawidłowe działanie Usług.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Twoja pełna odpowiedzialność za treści wejściowe i wygenerowane treści',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Rozumiesz i zgadzasz się, że wszystkie treści wejściowe przekazywane do Usług (w tym między innymi polecenia tekstowe, ustawienia parametrów, przykłady referencyjne, przesyłane obrazy, wideo, audio, szablony projektowe itp.) muszą być zgodne z prawem, zgodne z regulacjami i nie mogą naruszać praw osób trzecich. Gwarantujesz, że posiadasz pełne i wolne od wad prawa własności intelektualnej do takich treści lub uzyskałeś zgodne z prawem upoważnienie.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Usługi generują odpowiednie treści na podstawie Twoich danych wejściowych (dalej „Treści Wygenerowane”). Ponosisz pełną odpowiedzialność prawną za Treści Wygenerowane, w tym między innymi za zgodność treści z prawem, naruszenie własności intelektualnej, naruszenie dóbr osobistych oraz ryzyka handlowe. Powinieneś samodzielnie dokonać niezbędnego przeglądu, oceny i modyfikacji Treści Wygenerowanych, aby upewnić się, że nie naruszają one Niniejszej Polityki, Umowy Głównej ani obowiązujących przepisów prawa.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Odpowiedzialność za publikację na platformach osób trzecich',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Jeżeli publikujesz Treści Wygenerowane na platformach osób trzecich (takich jak media społecznościowe, systemy reklamowe, platformy e-commerce itp.), musisz przestrzegać zasad obowiązujących na tych platformach. Wszelkie kary, straty lub spory prawne wynikające z takiej publikacji ponosisz wyłącznie Ty i nie mają one związku z naszą platformą.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Szczególne przypomnienie',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Treści wygenerowane przez AI mogą podlegać ograniczeniom technicznym, takim jak dane treningowe i logika algorytmów, i nie gwarantują absolutnej dokładności, nieszkodliwości ani zgodności z określonymi wymogami prawnymi. Nie możesz powoływać się na fakt, że treść została „wygenerowana przez AI”, aby uchylić się od własnej odpowiedzialności prawnej.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Nasze prawa do nadzoru i egzekwowania',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Mamy prawo (ale nie obowiązek) nadzorować, przeglądać lub kontrolować korzystanie przez Ciebie z Usług oraz Treści Wygenerowane. Jeśli stwierdzimy lub otrzymamy uzasadnione zgłoszenie, że Ty lub jakakolwiek osoba korzystająca z Usług za pośrednictwem Twojego konta naruszyła Niniejszą Politykę, możemy według własnego uznania podjąć jedno lub więcej z poniższych działań bez wcześniejszego powiadomienia:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Wysłać do Ciebie pisemne ostrzeżenie i zażądać usunięcia naruszeń w wyznaczonym terminie;',
                            '2) Usunąć, zablokować lub uniemożliwić dostęp do treści naruszających zasady;',
                            '3) Zawiesić lub zakończyć całość lub część Twojego dostępu do Usług;',
                            '4) Trwale zamknąć Twoje konto i zakazać ponownej rejestracji;',
                            '5) Zgłosić lub ujawnić informacje o Twoim koncie i zapisy korzystania odpowiednim organom ścigania, organom regulacyjnym lub podmiotom uprawnionym;',
                            '6) Dochodzić Twojej odpowiedzialności za naruszenie umowy lub naruszenie prawa zgodnie z obowiązującymi przepisami, w tym między innymi żądać naprawienia wszelkich szkód poniesionych przez nas i/lub osoby trzecie (w tym między innymi kosztów postępowania, honorariów adwokackich, odszkodowań itp.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Powyższe środki nie wpływają na inne prawa, które możemy dochodzić na podstawie Umowy Głównej lub innych powiązanych umów.',
                    },
                ],
            },
            {
                title: '4. Kanały zgłoszeń i skarg',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Jeśli podczas korzystania z Usług zauważysz, że jakikolwiek użytkownik lub jakiekolwiek treści mogą naruszać Niniejszą Politykę (na przykład treści pornograficzne, treści naruszające prawa lub inne naruszenia), zachęcamy do zgłoszenia lub złożenia skargi w jeden z poniższych sposobów:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) E-mail: {email}',
                            '2) Obsługa klienta online: zaloguj się na swoje konto WeryAI, przejdź do strony rozliczeń lub centrum pomocy, kliknij przycisk funkcji obsługi klienta i prześlij odpowiednie informacje',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Rozpatrzymy zgłoszoną treść w rozsądnym terminie i podejmiemy odpowiednie działania zgodnie z Niniejszą Polityką oraz obowiązującymi przepisami prawa. Pamiętaj, że możemy nie być w stanie odpowiedzieć indywidualnie na każde zgłoszenie, ale zobowiązujemy się traktować każde ważne zgłoszenie poważnie.',
                    },
                ],
            },
            {
                title: '5. Aktualizacje i zmiany Niniejszej Polityki',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Możemy okresowo zmieniać lub aktualizować Niniejszą Politykę w związku z rozwojem działalności, zmianami technologicznymi, wymogami prawnymi i regulacyjnymi lub zmianami najlepszych praktyk branżowych. Zaktualizowana Polityka zostanie przekazana Ci za pomocą jednego lub większej liczby następujących sposobów:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Opublikowanie ogłoszenia na oficjalnej stronie internetowej WeryAI (https://weryai.com);',
                            '2) Wysłanie powiadomienia na Twój zarejestrowany adres e-mail;',
                            '3) Poinformowanie za pomocą wiadomości w serwisie, wyskakujących okienek lub innych metod.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Zmieniona Polityka wchodzi w życie w dniu obowiązywania wskazanym w ogłoszeniu. Jeśli nadal korzystasz z Usług, oznacza to, że akceptujesz zaktualizowaną Politykę i zgadzasz się jej przestrzegać; jeśli nie akceptujesz aktualizacji, przestań korzystać z Usług.',
                    },
                ],
            },
        ],
        seoDescription:
            'Polityka dopuszczalnego użytkowania WeryAI opisująca zakazane treści i działania, odpowiedzialność użytkownika, nadzór i egzekwowanie, kanały zgłoszeń oraz aktualizacje polityki.',
    },
    es: {
        title: 'Política de Uso Aceptable de WeryAI',
        introTitle: 'Introducción',
        intro: [
            'Esta Política de Uso Aceptable (en adelante, la “Política”) forma parte integrante del Acuerdo de Servicio de WeryAI (en adelante, el “Acuerdo Principal”). Al acceder o utilizar cualquiera de los servicios proporcionados por WeryAI (incluidos, entre otros, la versión web, las aplicaciones móviles y las funciones relacionadas de generación de contenido con inteligencia artificial, denominados colectivamente los “Servicios”), usted (en adelante, el “Usuario” o “usted”) acepta cumplir todos los términos de esta Política.',
            'El objetivo de esta Política es prohibir de forma expresa el uso de los Servicios para generar, cargar, difundir o almacenar cualquier contenido ilegal, inapropiado o que perjudique los derechos e intereses legítimos de terceros, especialmente contenido pornográfico, desnudez, insinuaciones sexuales y otras conductas que infrinjan el orden público, la moral o las leyes y normativas aplicables. Si no acepta esta Política, deje de utilizar los Servicios inmediatamente.',
        ],
        sections: [
            {
                title: '1. Contenido y conductas prohibidos',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Durante el uso de los Servicios, usted no podrá, por sí solo o junto con otros, realizar ninguno de los siguientes actos, ni ayudar, alentar o inducir a otros a realizarlos:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Contenido pornográfico, desnudez e insinuaciones sexuales',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Prohibimos estrictamente el uso de los Servicios para cualquier finalidad relacionada con la pornografía, la obscenidad, la desnudez o las insinuaciones sexuales, incluyendo, entre otras, las siguientes:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Generar o difundir contenido pornográfico: utilizar los Servicios para generar, cargar, compartir, mostrar o transmitir cualquier contenido que contenga o sugiera actos sexuales, provocación sexual, insinuaciones sexuales, lenguaje obsceno, descripciones pornográficas, órganos sexuales expuestos, animación pornográfica, audio pornográfico, video pornográfico, creación de textos pornográficos u otros contenidos similares;',
                                    '2) Interacciones pornográficas y juego de roles: realizar chats pornográficos, juegos de rol pornográficos, descripciones de fantasías sexuales, invitaciones sexuales o cualquier forma de interacción sexual virtual a través de los Servicios;',
                                    '3) Redirección a plataformas y recursos pornográficos: proporcionar, publicar, promocionar o dirigir el acceso a sitios web pornográficos, aplicaciones pornográficas, enlaces a recursos pornográficos, grupos sociales pornográficos u otras plataformas de contenido para adultos;',
                                    '4) Uso pornográfico con fines comerciales: utilizar los Servicios para la producción, comercialización, publicidad, captación de tráfico o cualquier forma de actividad pornográfica comercial.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Contenido ilegal, infractor y perjudicial',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Usted no podrá utilizar los Servicios para generar, cargar, almacenar o difundir el siguiente contenido ni realizar conductas relacionadas:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Contenido que viole leyes y normativas: incluyendo, entre otros, contenido que ponga en peligro la seguridad nacional, subvierta el poder del Estado, socave la unidad nacional, incite al odio étnico o promueva el terrorismo, el extremismo o el separatismo;',
                                    '2) Contenido que infrinja los derechos e intereses legítimos de terceros: incluyendo, entre otros, el uso no autorizado de materiales protegidos por derechos de autor, marcas registradas, patentes u otros derechos de propiedad intelectual, o contenido que infrinja derechos de imagen, privacidad, reputación, nombre, secretos comerciales u otros derechos;',
                                    '3) Contenido violento, de odio o discriminatorio: contenido que ataque, insulte, amenace, acose, discrimine o incite a la violencia contra grupos o personas por motivos de raza, etnia, religión, género, orientación sexual, edad, condición física o mental, nacionalidad, región u otras características;',
                                    '4) Contenido falso, fraudulento o engañoso: incluyendo, entre otros, la creación de noticias falsas, la falsificación de identidad, la realización de fraudes, ataques de phishing, la publicación de anuncios falsos o información comercial engañosa;',
                                    '5) Abuso técnico: incluyendo, entre otros, la carga de virus, código malicioso o troyanos, el uso de rastreadores o bots para acceder masivamente a los Servicios, la explotación de fallos técnicos para eludir restricciones del servicio, la realización de ataques de denegación de servicio u otras conductas que alteren el funcionamiento normal de los Servicios.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Su responsabilidad total sobre el contenido de entrada y el contenido generado',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Usted entiende y acepta que todo el contenido de entrada que proporcione a los Servicios (incluidos, entre otros, indicaciones de texto, configuraciones de parámetros, casos de referencia, imágenes, videos, audios y plantillas de diseño cargados, etc.) debe ser legal, conforme a la normativa y no infringir derechos de terceros. Usted garantiza que posee derechos de propiedad intelectual completos y sin defectos sobre dicho contenido o que ha obtenido una autorización legal.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Los Servicios generan el contenido correspondiente con base en su entrada (en adelante, el “Contenido Generado”). Usted asume toda la responsabilidad legal por el Contenido Generado, incluyendo, entre otros, la conformidad del contenido, la infracción de propiedad intelectual, la infracción de derechos de la personalidad y los riesgos comerciales. Usted deberá revisar, evaluar y modificar por su cuenta el Contenido Generado según sea necesario para asegurarse de que no infrinja esta Política, el Acuerdo Principal ni ninguna ley o normativa aplicable.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Responsabilidad por la publicación en plataformas de terceros',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Si publica Contenido Generado en plataformas de terceros (como redes sociales, sistemas publicitarios, plataformas de comercio electrónico, etc.), debe cumplir las normas de dichas plataformas. Cualquier sanción, pérdida o disputa legal derivada de dicha publicación será asumida exclusivamente por usted y no tendrá relación alguna con esta plataforma.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Recordatorio especial',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'El contenido generado por IA puede estar sujeto a limitaciones técnicas, como los datos de entrenamiento y la lógica algorítmica, y no se garantiza que sea absolutamente exacto, inocuo o conforme con requisitos legales específicos. Usted no podrá alegar que el contenido fue “generado por IA” para eximirse de su propia responsabilidad legal.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Nuestros derechos de supervisión y ejecución',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Tenemos el derecho (pero no la obligación) de supervisar, revisar o inspeccionar su uso de los Servicios y el Contenido Generado. Si descubrimos o recibimos una denuncia razonable de que usted, o cualquier persona que utilice los Servicios a través de su cuenta, ha infringido esta Política, podremos, a nuestra entera discreción, adoptar una o más de las siguientes medidas sin previo aviso:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Emitirle una advertencia por escrito y exigir la corrección dentro de un plazo determinado;',
                            '2) Eliminar, bloquear o prohibir el acceso al contenido infractor;',
                            '3) Suspender o terminar la totalidad o parte de su acceso a los Servicios;',
                            '4) Cerrar permanentemente su cuenta y prohibirle registrarse de nuevo;',
                            '5) Informar o divulgar la información de su cuenta y sus registros de uso a las autoridades de aplicación de la ley, organismos reguladores o titulares de derechos pertinentes;',
                            '6) Exigir su responsabilidad por incumplimiento contractual o infracción conforme a la ley, incluyendo, entre otros, reclamarle la compensación por todas las pérdidas sufridas por nosotros y/o terceros como consecuencia de ello (incluidos, entre otros, costos judiciales, honorarios de abogados, indemnizaciones, etc.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Las medidas anteriores no afectarán a cualquier otro derecho que podamos reclamar en virtud del Acuerdo Principal o de otros acuerdos relacionados.',
                    },
                ],
            },
            {
                title: '4. Canales de denuncia y reclamación',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Si durante el uso de los Servicios detecta que cualquier usuario o cualquier contenido puede infringir esta Política (por ejemplo, contenido pornográfico, contenido infractor u otras infracciones), le animamos a denunciárnoslo o presentar una reclamación a través de los siguientes medios:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Correo electrónico: {email}',
                            '2) Atención al cliente en línea: inicie sesión en su cuenta de WeryAI, vaya a la página de facturación o al centro de ayuda, haga clic en el botón de atención al cliente y envíe la información pertinente',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Revisaremos el contenido denunciado en un plazo razonable y adoptaremos las medidas correspondientes de acuerdo con esta Política y las leyes y normativas aplicables. Tenga en cuenta que es posible que no podamos responder individualmente a cada denuncia, pero nos comprometemos a tratar seriamente cada denuncia válida.',
                    },
                ],
            },
            {
                title: '5. Actualizaciones y modificaciones de esta Política',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Podremos revisar o actualizar esta Política periódicamente en función del desarrollo del negocio, los cambios tecnológicos, los requisitos legales y normativos o los cambios en las mejores prácticas del sector. La Política actualizada se le notificará mediante una o más de las siguientes formas:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Publicación de un anuncio en el sitio web oficial de WeryAI (https://weryai.com);',
                            '2) Envío de una notificación a su correo electrónico registrado;',
                            '3) Avisos mediante mensajes dentro del sitio, ventanas emergentes u otros medios.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'La Política revisada entrará en vigor en la fecha indicada en el anuncio. Si continúa utilizando los Servicios, significará que acepta y se compromete a cumplir la Política actualizada; si no acepta la actualización, deje de utilizar los Servicios.',
                    },
                ],
            },
        ],
        seoDescription:
            'Política de Uso Aceptable de WeryAI que describe el contenido y las conductas prohibidas, la responsabilidad del usuario, la supervisión y ejecución, los canales de denuncia y las actualizaciones de la política.',
    },
    fr: {
        title: "Politique d'utilisation acceptable de WeryAI",
        introTitle: 'Introduction',
        intro: [
            "La présente Politique d'utilisation acceptable (ci-après la « Politique ») fait partie intégrante du Contrat de services WeryAI (ci-après le « Contrat principal »). En accédant à tout service fourni par WeryAI ou en l'utilisant (y compris, sans s'y limiter, la version Web, les applications mobiles et les fonctionnalités associées de génération de contenu par intelligence artificielle, ci-après collectivement les « Services »), vous (ci-après l'« Utilisateur » ou « vous ») acceptez de respecter l'ensemble des dispositions de la présente Politique.",
            "La présente Politique vise à interdire expressément l'utilisation des Services pour générer, téléverser, diffuser ou stocker tout contenu illégal, inapproprié ou portant atteinte aux droits et intérêts légitimes d'autrui, notamment les contenus pornographiques, la nudité, les insinuations sexuelles et tout autre comportement contraire à l'ordre public, aux bonnes moeurs ou aux lois et réglementations applicables. Si vous n'acceptez pas la présente Politique, veuillez cesser immédiatement d'utiliser les Services.",
        ],
        sections: [
            {
                title: '1. Contenus et comportements interdits',
                blocks: [
                    {
                        type: 'paragraph',
                        text: "Dans le cadre de l'utilisation des Services, vous ne devez pas, seul ou avec d'autres, vous livrer à l'un quelconque des comportements suivants, ni aider, encourager ou inciter autrui à s'y livrer :",
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Contenus pornographiques, nudité et insinuations sexuelles',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: "Nous interdisons strictement l'utilisation des Services à toute fin liée à la pornographie, à l'obscénité, à la nudité ou aux insinuations sexuelles, y compris, sans s'y limiter :",
                            },
                            {
                                type: 'list',
                                items: [
                                    "1) Génération ou diffusion de contenus pornographiques : utiliser les Services pour générer, téléverser, partager, afficher ou transmettre tout contenu contenant ou suggérant des actes sexuels, de la provocation sexuelle, des insinuations sexuelles, un langage obscène, des descriptions pornographiques, des organes sexuels exposés, des animations pornographiques, des contenus audio pornographiques, des vidéos pornographiques, des créations textuelles pornographiques ou des contenus similaires ;",
                                    "2) Interactions pornographiques et jeux de rôle : effectuer via les Services des discussions pornographiques, des jeux de rôle pornographiques, des descriptions de fantasmes sexuels, des invitations sexuelles ou toute forme d'interaction sexuelle virtuelle ;",
                                    "3) Orientation vers des plateformes et ressources pornographiques : fournir, publier, promouvoir ou orienter l'accès vers tout site pornographique, application pornographique, lien vers des ressources pornographiques, groupe social pornographique ou autre plateforme de contenu pour adultes ;",
                                    "4) Utilisation pornographique à des fins commerciales : utiliser les Services pour la production, la transaction, la publicité, l'acquisition de trafic ou toute autre activité pornographique à caractère commercial.",
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Contenus illégaux, contrefaisants et nuisibles',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: "Vous ne devez pas utiliser les Services pour générer, téléverser, stocker ou diffuser les contenus suivants, ni vous livrer à des comportements connexes :",
                            },
                            {
                                type: 'list',
                                items: [
                                    "1) Contenus violant les lois et règlements : y compris, sans s'y limiter, les contenus portant atteinte à la sécurité nationale, renversant le pouvoir de l'État, compromettant l'unité nationale, incitant à la haine ethnique ou faisant l'apologie du terrorisme, de l'extrémisme ou du séparatisme ;",
                                    "2) Contenus portant atteinte aux droits et intérêts légitimes d'autrui : y compris, sans s'y limiter, l'utilisation non autorisée de matériaux protégés par des droits d'auteur, des marques, des brevets ou d'autres droits de propriété intellectuelle, ou des contenus portant atteinte aux droits à l'image, à la vie privée, à la réputation, au nom, aux secrets commerciaux ou à d'autres droits ;",
                                    "3) Contenus violents, haineux ou discriminatoires : contenus attaquant, insultant, menaçant, harcelant, discriminant ou incitant à la violence à l'égard de groupes ou de personnes en raison de leur race, origine ethnique, religion, sexe, orientation sexuelle, âge, condition physique ou mentale, nationalité, région ou autres caractéristiques ;",
                                    "4) Contenus faux, frauduleux ou trompeurs : y compris, sans s'y limiter, la fabrication de fausses informations, l'usurpation d'identité, la commission d'escroqueries, les attaques de phishing, la publication de fausses publicités ou d'informations commerciales trompeuses ;",
                                    "5) Abus techniques : y compris, sans s'y limiter, le téléversement de virus, de code malveillant ou de chevaux de Troie, l'utilisation de robots d'exploration ou de bots pour accéder massivement aux Services, l'exploitation de failles techniques pour contourner les restrictions de service, la réalisation d'attaques par déni de service ou toute autre action perturbant le fonctionnement normal des Services.",
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Votre entière responsabilité quant au contenu saisi et au contenu généré',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: "Vous comprenez et acceptez que tout le contenu saisi que vous fournissez aux Services (y compris, sans s'y limiter, les instructions textuelles, les paramètres, les cas de référence, les images, vidéos, audios et modèles de conception téléversés, etc.) doit être légal, conforme et ne pas porter atteinte aux droits de tiers. Vous garantissez que vous détenez des droits de propriété intellectuelle complets et exempts de tout vice sur ce contenu ou que vous avez obtenu une autorisation légale.",
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Les Services génèrent le contenu correspondant sur la base de vos saisies (ci-après le « Contenu généré »). Vous assumez l’entière responsabilité juridique du Contenu généré, y compris, sans s’y limiter, sa conformité, toute atteinte à la propriété intellectuelle, aux droits de la personnalité et les risques commerciaux. Il vous appartient de procéder aux vérifications, évaluations et modifications nécessaires afin de vous assurer que le Contenu généré ne viole pas la présente Politique, le Contrat principal ni aucune loi ou réglementation applicable.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Responsabilité liée à la publication sur des plateformes tierces',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: "Si vous publiez le Contenu généré sur des plateformes tierces (telles que les réseaux sociaux, les systèmes publicitaires, les plateformes de commerce électronique, etc.), vous devez respecter les règles de ces plateformes. Toute sanction, perte ou tout litige juridique résultant de cette publication sera à votre seule charge et n'aura aucun lien avec notre plateforme.",
                            },
                        ],
                    },
                    {
                        title: '2.4 Rappel particulier',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Le contenu généré par IA peut être soumis à des limitations techniques, telles que les données d’entraînement et la logique algorithmique, et il n’est pas garanti comme étant absolument exact, inoffensif ou conforme à des exigences légales spécifiques. Vous ne pouvez pas invoquer le fait que le contenu a été « généré par IA » pour vous exonérer de votre propre responsabilité juridique.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Nos droits de supervision et d’exécution',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Nous avons le droit (mais non l’obligation) de superviser, d’examiner ou de contrôler votre utilisation des Services et le Contenu généré. Si nous découvrons ou recevons un signalement raisonnable selon lequel vous, ou toute personne utilisant les Services via votre compte, avez violé la présente Politique, nous pouvons, à notre seule discrétion, prendre une ou plusieurs des mesures suivantes sans préavis :',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Vous adresser un avertissement écrit et exiger une rectification dans un délai déterminé ;',
                            '2) Supprimer, bloquer ou interdire l’accès au contenu en infraction ;',
                            '3) Suspendre ou résilier tout ou partie de votre accès aux Services ;',
                            '4) Fermer définitivement votre compte et vous interdire de vous réinscrire ;',
                            '5) Signaler ou divulguer les informations de votre compte et vos enregistrements d’utilisation aux autorités compétentes, organismes de régulation ou titulaires de droits concernés ;',
                            '6) Engager votre responsabilité pour violation contractuelle ou atteinte aux droits conformément à la loi, y compris, sans s’y limiter, en vous demandant de réparer l’intégralité des pertes subies par nous et/ou par des tiers de ce fait (y compris, sans s’y limiter, les frais de justice, honoraires d’avocat, dommages-intérêts, etc.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Les mesures ci-dessus n’affectent en rien tout autre droit que nous pourrions faire valoir en vertu du Contrat principal ou de tout autre accord connexe.',
                    },
                ],
            },
            {
                title: '4. Canaux de signalement et de réclamation',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Si, dans le cadre de votre utilisation des Services, vous constatez qu’un utilisateur ou qu’un contenu pourrait enfreindre la présente Politique (par exemple, un contenu pornographique, un contenu portant atteinte aux droits ou toute autre violation), nous vous encourageons à nous le signaler ou à déposer une réclamation par l’un des moyens suivants :',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) E-mail : {email}',
                            '2) Service client en ligne : connectez-vous à votre compte WeryAI, accédez à la page de facturation ou au centre d’aide, cliquez sur le bouton du service client et soumettez les informations pertinentes',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Nous examinerons le contenu signalé dans un délai raisonnable et prendrons les mesures appropriées conformément à la présente Politique et aux lois et règlements applicables. Veuillez noter que nous ne pourrons peut-être pas répondre individuellement à chaque signalement, mais nous nous engageons à traiter sérieusement chaque signalement valable.',
                    },
                ],
            },
            {
                title: '5. Mises à jour et modifications de la présente Politique',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Nous pouvons réviser ou mettre à jour périodiquement la présente Politique en fonction de l’évolution de notre activité, des changements technologiques, des exigences légales et réglementaires ou de l’évolution des meilleures pratiques du secteur. La Politique mise à jour vous sera communiquée par un ou plusieurs des moyens suivants :',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Publication d’une annonce sur le site officiel de WeryAI (https://weryai.com) ;',
                            '2) Envoi d’une notification à votre adresse e-mail enregistrée ;',
                            '3) Information via des messages sur le site, des fenêtres contextuelles ou d’autres moyens.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'La Politique révisée prendra effet à la date d’entrée en vigueur indiquée dans l’annonce. Si vous continuez à utiliser les Services, cela signifie que vous acceptez la Politique mise à jour et vous engagez à la respecter ; si vous n’acceptez pas la mise à jour, veuillez cesser d’utiliser les Services.',
                    },
                ],
            },
        ],
        seoDescription:
            'Politique d’utilisation acceptable de WeryAI décrivant les contenus et comportements interdits, la responsabilité de l’utilisateur, la supervision et l’exécution, les canaux de signalement et les mises à jour de la politique.',
    },
    de: {
        title: 'Richtlinie zur zulässigen Nutzung von WeryAI',
        introTitle: 'Einleitung',
        intro: [
            'Diese Richtlinie zur zulässigen Nutzung (nachfolgend „diese Richtlinie“) ist Bestandteil des WeryAI-Dienstleistungsvertrags (nachfolgend „Hauptvertrag“). Indem Sie auf von WeryAI bereitgestellte Dienste zugreifen oder diese nutzen (einschließlich, aber nicht beschränkt auf die Webversion, mobile Anwendungen und zugehörige KI-Funktionen zur Inhaltserstellung, nachfolgend gemeinsam die „Dienste“), erklären Sie (nachfolgend „Nutzer“ oder „Sie“), dass Sie alle Bestimmungen dieser Richtlinie einhalten.',
            'Zweck dieser Richtlinie ist es, die Nutzung der Dienste zur Erstellung, zum Hochladen, zur Verbreitung oder Speicherung von rechtswidrigen, unangemessenen oder die legitimen Rechte und Interessen Dritter verletzenden Inhalten ausdrücklich zu untersagen, insbesondere pornografische Inhalte, Nacktheit, sexuelle Anspielungen sowie sonstige Verhaltensweisen, die gegen die öffentliche Ordnung, die guten Sitten oder geltendes Recht verstoßen. Wenn Sie diese Richtlinie nicht akzeptieren, stellen Sie die Nutzung der Dienste bitte unverzüglich ein.',
        ],
        sections: [
            {
                title: '1. Verbotene Inhalte und Verhaltensweisen',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Bei der Nutzung der Dienste dürfen Sie weder allein noch gemeinsam mit anderen eine der folgenden Handlungen vornehmen; ebenso wenig dürfen Sie andere dabei unterstützen, dazu ermutigen oder dazu veranlassen:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Pornografische Inhalte, Nacktheit und sexuelle Anspielungen',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Wir untersagen streng die Nutzung der Dienste für jegliche Zwecke im Zusammenhang mit Pornografie, Obszönität, Nacktheit oder sexuellen Anspielungen, einschließlich, aber nicht beschränkt auf:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Erstellung oder Verbreitung pornografischer Inhalte: Nutzung der Dienste zur Erstellung, zum Hochladen, Teilen, Anzeigen oder Übermitteln von Inhalten, die sexuelle Handlungen, sexuelle Provokation, sexuelle Anspielungen, obszöne Sprache, pornografische Beschreibungen, entblößte Geschlechtsorgane, pornografische Animationen, pornografische Audiodateien, pornografische Videos, pornografische Texterstellung oder ähnliche Inhalte enthalten oder andeuten;',
                                    '2) Pornografische Interaktionen und Rollenspiele: Durchführung pornografischer Chats, pornografischer Rollenspiele, Beschreibungen sexueller Fantasien, sexueller Einladungen oder jeglicher Form virtueller sexueller Interaktion über die Dienste;',
                                    '3) Weiterleitung zu pornografischen Plattformen und Ressourcen: Bereitstellung, Veröffentlichung, Bewerbung oder Lenkung des Zugangs zu pornografischen Websites, pornografischen Apps, Links zu pornografischen Ressourcen, pornografischen sozialen Gruppen oder sonstigen Plattformen mit Erwachseneninhalt;',
                                    '4) Kommerzielle pornografische Nutzung: Nutzung der Dienste zur Produktion, zum Handel, zur Werbung, zur Traffic-Generierung oder zu jeglicher Form kommerzieller pornografischer Aktivitäten.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Rechtswidrige, rechtsverletzende und schädliche Inhalte',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Sie dürfen die Dienste nicht nutzen, um folgende Inhalte zu erstellen, hochzuladen, zu speichern oder zu verbreiten oder damit verbundene Handlungen vorzunehmen:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Inhalte, die gegen Gesetze und Vorschriften verstoßen: einschließlich, aber nicht beschränkt auf Inhalte, die die nationale Sicherheit gefährden, die Staatsgewalt untergraben, die nationale Einheit beeinträchtigen, ethnischen Hass schüren oder Terrorismus, Extremismus oder Separatismus propagieren;',
                                    '2) Inhalte, die die legitimen Rechte und Interessen Dritter verletzen: einschließlich, aber nicht beschränkt auf die unbefugte Nutzung von Materialien, die durch Urheberrechte, Markenrechte, Patente oder sonstige Rechte des geistigen Eigentums geschützt sind, oder Inhalte, die Bildrechte, Datenschutzrechte, Persönlichkeitsrechte, Namensrechte, Geschäftsgeheimnisse oder sonstige Rechte verletzen;',
                                    '3) Gewalt-, Hass- oder diskriminierende Inhalte: Inhalte, die Gruppen oder Einzelpersonen aufgrund von Rasse, ethnischer Herkunft, Religion, Geschlecht, sexueller Orientierung, Alter, körperlichem oder geistigem Zustand, Nationalität, Region oder anderen Merkmalen angreifen, beleidigen, bedrohen, belästigen, diskriminieren oder zu Gewalt aufstacheln;',
                                    '4) Falsche, betrügerische oder irreführende Inhalte: einschließlich, aber nicht beschränkt auf die Erstellung von Falschmeldungen, Identitätsfälschung, Betrug, Phishing-Angriffe, die Veröffentlichung falscher Werbung oder irreführender geschäftlicher Informationen;',
                                    '5) Technischer Missbrauch: einschließlich, aber nicht beschränkt auf das Hochladen von Viren, Schadcode oder Trojanern, den Einsatz von Crawlern oder Bots für Massenzugriffe auf die Dienste, die Ausnutzung technischer Schwachstellen zur Umgehung von Dienstbeschränkungen, die Durchführung von Denial-of-Service-Angriffen oder sonstige Handlungen, die den ordnungsgemäßen Betrieb der Dienste stören.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Ihre volle Verantwortung für Eingabeinhalte und generierte Inhalte',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Sie verstehen und erklären sich damit einverstanden, dass sämtliche Inhalte, die Sie den Diensten als Eingabe zur Verfügung stellen (einschließlich, aber nicht beschränkt auf Textanweisungen, Parametereinstellungen, Referenzfälle, hochgeladene Bilder, Videos, Audiodateien und Designvorlagen usw.), rechtmäßig, regelkonform und frei von Rechten Dritter sein müssen. Sie gewährleisten, dass Sie vollständige und mangelfreie Rechte des geistigen Eigentums an diesen Inhalten besitzen oder eine rechtmäßige Genehmigung erhalten haben.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Die Dienste generieren auf Grundlage Ihrer Eingaben entsprechende Inhalte (nachfolgend „generierte Inhalte“). Sie tragen die volle rechtliche Verantwortung für die generierten Inhalte, einschließlich, aber nicht beschränkt auf deren rechtliche Zulässigkeit, Verstöße gegen geistiges Eigentum, Verletzungen von Persönlichkeitsrechten und wirtschaftliche Risiken. Sie müssen die generierten Inhalte eigenständig prüfen, bewerten und gegebenenfalls anpassen, um sicherzustellen, dass sie nicht gegen diese Richtlinie, den Hauptvertrag oder geltendes Recht verstoßen.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Verantwortung für die Veröffentlichung auf Plattformen Dritter',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Wenn Sie generierte Inhalte auf Plattformen Dritter veröffentlichen (wie soziale Medien, Werbesysteme, E-Commerce-Plattformen usw.), müssen Sie die Regeln dieser Plattformen einhalten. Sämtliche Sanktionen, Verluste oder Rechtsstreitigkeiten, die aus einer solchen Veröffentlichung entstehen, tragen allein Sie; sie stehen in keinem Zusammenhang mit unserer Plattform.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Besonderer Hinweis',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'KI-generierte Inhalte können technischen Einschränkungen unterliegen, etwa aufgrund von Trainingsdaten oder algorithmischer Logik, und es wird nicht garantiert, dass sie absolut korrekt, unbedenklich oder mit bestimmten rechtlichen Anforderungen vereinbar sind. Sie können sich nicht mit dem Hinweis entlasten, der Inhalt sei „von KI generiert“ worden.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Unsere Rechte zur Überwachung und Durchsetzung',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Wir haben das Recht (aber nicht die Pflicht), Ihre Nutzung der Dienste sowie die generierten Inhalte zu überwachen, zu prüfen oder stichprobenartig zu kontrollieren. Wenn wir feststellen oder eine begründete Meldung erhalten, dass Sie oder eine Person, die die Dienste über Ihr Konto nutzt, gegen diese Richtlinie verstoßen hat, können wir nach eigenem Ermessen ohne vorherige Ankündigung eine oder mehrere der folgenden Maßnahmen ergreifen:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Ihnen eine schriftliche Warnung erteilen und innerhalb einer bestimmten Frist Abhilfe verlangen;',
                            '2) Rechtsverletzende Inhalte löschen, sperren oder den Zugriff darauf untersagen;',
                            '3) Ihren Zugang zu den Diensten ganz oder teilweise aussetzen oder beenden;',
                            '4) Ihr Konto dauerhaft schließen und Ihnen eine erneute Registrierung untersagen;',
                            '5) Ihre Kontoinformationen und Nutzungsaufzeichnungen an zuständige Strafverfolgungsbehörden, Aufsichtsbehörden oder Rechteinhaber melden oder offenlegen;',
                            '6) Ihre Haftung wegen Vertragsverletzung oder Rechtsverletzung nach geltendem Recht geltend machen, einschließlich, aber nicht beschränkt auf den Ersatz sämtlicher dadurch entstandener Verluste von uns und/oder Dritten (einschließlich, aber nicht beschränkt auf Prozesskosten, Anwaltsgebühren, Schadensersatz usw.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Die vorstehenden Maßnahmen berühren keine weiteren Rechte, die wir nach dem Hauptvertrag oder anderen einschlägigen Vereinbarungen geltend machen können.',
                    },
                ],
            },
            {
                title: '4. Melde- und Beschwerdekanäle',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Wenn Sie bei der Nutzung der Dienste feststellen, dass ein Nutzer oder Inhalte möglicherweise gegen diese Richtlinie verstoßen (zum Beispiel pornografische Inhalte, rechtsverletzende Inhalte oder sonstige Verstöße), empfehlen wir Ihnen, uns dies auf einem der folgenden Wege zu melden oder eine Beschwerde einzureichen:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) E-Mail: {email}',
                            '2) Online-Kundendienst: Melden Sie sich bei Ihrem WeryAI-Konto an, öffnen Sie die Abrechnungsseite oder das Hilfezentrum, klicken Sie auf die Kundendienstfunktion und übermitteln Sie die relevanten Informationen',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Wir werden die gemeldeten Inhalte innerhalb eines angemessenen Zeitraums prüfen und gemäß dieser Richtlinie sowie den geltenden Gesetzen und Vorschriften geeignete Maßnahmen ergreifen. Bitte beachten Sie, dass wir möglicherweise nicht auf jede Meldung individuell antworten können, aber wir verpflichten uns, jede berechtigte Meldung ernsthaft zu behandeln.',
                    },
                ],
            },
            {
                title: '5. Aktualisierungen und Änderungen dieser Richtlinie',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Wir können diese Richtlinie von Zeit zu Zeit auf Grundlage der Geschäftsentwicklung, technologischer Veränderungen, gesetzlicher und regulatorischer Anforderungen oder Änderungen bewährter Branchenpraktiken überarbeiten oder aktualisieren. Die aktualisierte Richtlinie wird Ihnen auf einem oder mehreren der folgenden Wege mitgeteilt:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Veröffentlichung einer Bekanntmachung auf der offiziellen WeryAI-Website (https://weryai.com);',
                            '2) Zusendung einer Benachrichtigung an Ihre registrierte E-Mail-Adresse;',
                            '3) Mitteilung über Nachrichten innerhalb der Website, Pop-up-Hinweise oder andere Wege.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Die überarbeitete Richtlinie tritt an dem in der Bekanntmachung genannten Datum in Kraft. Wenn Sie die Dienste weiterhin nutzen, bedeutet dies, dass Sie die aktualisierte Richtlinie akzeptieren und sich zu ihrer Einhaltung verpflichten; wenn Sie die Aktualisierung nicht akzeptieren, stellen Sie die Nutzung der Dienste bitte ein.',
                    },
                ],
            },
        ],
        seoDescription:
            'Richtlinie zur zulässigen Nutzung von WeryAI mit Beschreibung verbotener Inhalte und Verhaltensweisen, der Verantwortung des Nutzers, der Überwachung und Durchsetzung, der Meldekanäle sowie von Richtlinienaktualisierungen.',
    },
    ru: {
        title: 'Политика допустимого использования WeryAI',
        introTitle: 'Введение',
        intro: [
            'Настоящая Политика допустимого использования (далее «настоящая Политика») является составной частью Соглашения об оказании услуг WeryAI (далее «Основное соглашение»). Получая доступ к любым сервисам, предоставляемым WeryAI, или используя их (включая, помимо прочего, веб-версию, мобильные приложения и связанные функции генерации контента с использованием искусственного интеллекта, далее совместно именуемые «Сервисы»), вы (далее «Пользователь» или «вы») соглашаетесь соблюдать все положения настоящей Политики.',
            'Цель настоящей Политики заключается в том, чтобы прямо запретить использование Сервисов для создания, загрузки, распространения или хранения любого незаконного, ненадлежащего либо нарушающего законные права и интересы третьих лиц контента, особенно порнографии, наготы, сексуальных намеков и иных действий, нарушающих общественный порядок, мораль или применимое законодательство. Если вы не принимаете настоящую Политику, немедленно прекратите использование Сервисов.',
        ],
        sections: [
            {
                title: '1. Запрещенный контент и действия',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'При использовании Сервисов вы не должны ни самостоятельно, ни совместно с другими совершать какие-либо из следующих действий, а также не должны содействовать, поощрять или побуждать других к совершению таких действий:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Порнографический контент, нагота и сексуальные намеки',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Мы строго запрещаем использовать Сервисы для любых целей, связанных с порнографией, непристойностью, наготой или сексуальными намеками, включая, помимо прочего, следующее:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Создание или распространение порнографического контента: использование Сервисов для создания, загрузки, публикации, демонстрации или передачи любого контента, содержащего или подразумевающего сексуальные действия, сексуальное подстрекательство, сексуальные намеки, непристойную лексику, порнографические описания, обнаженные половые органы, порнографическую анимацию, порнографическое аудио, порнографическое видео, порнографические тексты и подобный контент;',
                                    '2) Порнографическое взаимодействие и ролевые игры: ведение порнографических чатов, порнографических ролевых игр, описаний сексуальных фантазий, сексуальных приглашений или любых форм виртуального сексуального взаимодействия через Сервисы;',
                                    '3) Направление к порнографическим платформам и ресурсам: предоставление, публикация, продвижение или направление доступа к порнографическим сайтам, порнографическим приложениям, ссылкам на порнографические ресурсы, порнографическим социальным группам или иным платформам с контентом для взрослых;',
                                    '4) Коммерческое использование в порнографических целях: использование Сервисов для производства, торговли, размещения рекламы, привлечения трафика или любой иной коммерческой порнографической деятельности.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Незаконный, нарушающий права и вредоносный контент',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Вы не должны использовать Сервисы для создания, загрузки, хранения или распространения следующего контента, а также для совершения связанных с ним действий:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Контент, нарушающий законы и нормативные акты: включая, помимо прочего, контент, угрожающий национальной безопасности, подрывающий государственную власть, нарушающий национальное единство, разжигающий этническую ненависть или пропагандирующий терроризм, экстремизм или сепаратизм;',
                                    '2) Контент, нарушающий законные права и интересы других лиц: включая, помимо прочего, несанкционированное использование материалов, защищенных авторским правом, товарными знаками, патентами или иными правами интеллектуальной собственности, а также контент, нарушающий право на изображение, право на частную жизнь, право на репутацию, право на имя, коммерческую тайну и иные права;',
                                    '3) Насильственный, ненавистнический или дискриминационный контент: контент, который нападает, оскорбляет, угрожает, преследует, дискриминирует или подстрекает к насилию в отношении групп или отдельных лиц по признаку расы, этнического происхождения, религии, пола, сексуальной ориентации, возраста, физического или психического состояния, национальности, региона или иных характеристик;',
                                    '4) Ложный, мошеннический или вводящий в заблуждение контент: включая, помимо прочего, создание фейковых новостей, подделку личности, совершение мошенничества, фишинговые атаки, публикацию ложной рекламы или вводящей в заблуждение коммерческой информации;',
                                    '5) Технические злоупотребления: включая, помимо прочего, загрузку вирусов, вредоносного кода, троянов, использование сканеров или ботов для массового доступа к Сервисам, эксплуатацию технических уязвимостей для обхода ограничений сервиса, проведение атак типа отказа в обслуживании или иные действия, нарушающие нормальную работу Сервисов.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Ваша полная ответственность за входной и сгенерированный контент',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Вы понимаете и соглашаетесь с тем, что весь входной контент, который вы предоставляете Сервисам (включая, помимо прочего, текстовые инструкции, параметры настройки, примеры, загружаемые изображения, видео, аудио, шаблоны дизайна и т. д.), должен быть законным, соответствующим требованиям и не нарушать права третьих лиц. Вы гарантируете, что обладаете полными и безупречными правами интеллектуальной собственности на такой контент либо получили законное разрешение.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Сервисы создают соответствующий контент на основе ваших входных данных (далее «Сгенерированный контент»). Вы несете полную юридическую ответственность за Сгенерированный контент, включая, помимо прочего, соответствие контента требованиям закона, нарушение прав интеллектуальной собственности, нарушение личных неимущественных прав и коммерческие риски. Вы обязаны самостоятельно проверять, оценивать и при необходимости изменять Сгенерированный контент, чтобы он не нарушал настоящую Политику, Основное соглашение и применимое законодательство.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Ответственность за публикацию на сторонних платформах',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Если вы публикуете Сгенерированный контент на сторонних платформах (например, в социальных сетях, рекламных системах, на платформах электронной торговли и т. д.), вы обязаны соблюдать правила этих платформ. Любые санкции, убытки или юридические споры, возникшие в результате такой публикации, несете исключительно вы и они не имеют отношения к нашей платформе.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Особое напоминание',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Контент, созданный ИИ, может быть ограничен техническими факторами, такими как обучающие данные и алгоритмическая логика, и не гарантируется как абсолютно точный, безвредный или соответствующий конкретным правовым требованиям. Вы не можете ссылаться на то, что контент был «создан ИИ», чтобы освободиться от собственной юридической ответственности.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Наши права по контролю и применению мер',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Мы имеем право (но не обязанность) контролировать, проверять или выборочно просматривать ваше использование Сервисов и Сгенерированный контент. Если мы обнаружим или получим обоснованное сообщение о том, что вы или любое лицо, использующее Сервисы через вашу учетную запись, нарушили настоящую Политику, мы по своему усмотрению можем без предварительного уведомления принять одну или несколько из следующих мер:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Направить вам письменное предупреждение и потребовать устранения нарушения в установленный срок;',
                            '2) Удалить, заблокировать или запретить доступ к нарушающему контенту;',
                            '3) Приостановить или прекратить полностью либо частично ваш доступ к Сервисам;',
                            '4) Навсегда закрыть вашу учетную запись и запретить вам повторную регистрацию;',
                            '5) Сообщить или раскрыть информацию о вашей учетной записи и записи использования соответствующим правоохранительным органам, регулирующим органам или правообладателям;',
                            '6) Привлечь вас к ответственности за нарушение договора или нарушение прав в соответствии с законом, включая, помимо прочего, требование возместить нам и/или третьим лицам все понесенные в связи с этим убытки (включая, помимо прочего, судебные расходы, гонорары адвокатов, компенсации и т. д.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Указанные выше меры не затрагивают любые иные права, которые мы можем заявлять на основании Основного соглашения или других связанных соглашений.',
                    },
                ],
            },
            {
                title: '4. Каналы для сообщений и жалоб',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Если в процессе использования Сервисов вы обнаружите, что какой-либо пользователь или какой-либо контент может нарушать настоящую Политику (например, порнографический контент, контент, нарушающий права, или иные нарушения), мы рекомендуем вам сообщить нам об этом или подать жалобу одним из следующих способов:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Электронная почта: {email}',
                            '2) Онлайн-служба поддержки: войдите в свою учетную запись WeryAI, перейдите на страницу выставления счетов или в справочный центр, нажмите кнопку службы поддержки и отправьте соответствующую информацию',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Мы рассмотрим сообщенный контент в разумный срок и примем соответствующие меры в соответствии с настоящей Политикой и применимым законодательством. Обратите внимание, что мы можем не иметь возможности отвечать индивидуально на каждое сообщение, однако обязуемся серьезно относиться к каждому обоснованному обращению.',
                    },
                ],
            },
            {
                title: '5. Обновления и изменения настоящей Политики',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Мы можем периодически пересматривать или обновлять настоящую Политику в зависимости от развития бизнеса, технологических изменений, требований законодательства и регулирования или изменений лучших отраслевых практик. Обновленная Политика будет доведена до вашего сведения одним или несколькими из следующих способов:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Публикация объявления на официальном сайте WeryAI (https://weryai.com);',
                            '2) Отправка уведомления на ваш зарегистрированный адрес электронной почты;',
                            '3) Информирование через сообщения на сайте, всплывающие окна или иные способы.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Пересмотренная Политика вступает в силу с даты, указанной в объявлении. Если вы продолжаете использовать Сервисы, это означает, что вы принимаете обновленную Политику и соглашаетесь ее соблюдать; если вы не принимаете обновление, прекратите использование Сервисов.',
                    },
                ],
            },
        ],
        seoDescription:
            'Политика допустимого использования WeryAI, описывающая запрещенный контент и действия, ответственность пользователя, контроль и применение мер, каналы для сообщений и обновления политики.',
    },
    pt: {
        title: 'Política de Uso Aceitável da WeryAI',
        introTitle: 'Introdução',
        intro: [
            'Esta Política de Uso Aceitável (doravante denominada “esta Política”) é parte integrante do Contrato de Serviços da WeryAI (doravante denominado “Contrato Principal”). Ao acessar ou utilizar quaisquer serviços fornecidos pela WeryAI (incluindo, entre outros, a versão web, aplicativos móveis e funcionalidades relacionadas de geração de conteúdo por inteligência artificial, doravante coletivamente denominados “Serviços”), você (doravante denominado “Usuário” ou “você”) concorda em cumprir todos os termos desta Política.',
            'O objetivo desta Política é proibir expressamente o uso dos Serviços para gerar, carregar, disseminar ou armazenar qualquer conteúdo ilegal, impróprio ou que prejudique os direitos e interesses legítimos de terceiros, especialmente pornografia, nudez, insinuações sexuais e outros comportamentos que violem a ordem pública, os bons costumes ou as leis e regulamentos aplicáveis. Se você não aceitar esta Política, interrompa imediatamente o uso dos Serviços.',
        ],
        sections: [
            {
                title: '1. Conteúdo e condutas proibidos',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Ao utilizar os Serviços, você não poderá, sozinho ou em conjunto com outras pessoas, praticar qualquer um dos atos a seguir, nem ajudar, incentivar ou induzir outras pessoas a praticá-los:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Conteúdo pornográfico, nudez e insinuações sexuais',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Proibimos estritamente o uso dos Serviços para qualquer finalidade relacionada à pornografia, obscenidade, nudez ou insinuações sexuais, incluindo, entre outras, as seguintes:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Gerar ou disseminar conteúdo pornográfico: usar os Serviços para gerar, carregar, compartilhar, exibir ou transmitir qualquer conteúdo que contenha ou sugira atos sexuais, provocação sexual, insinuações sexuais, linguagem obscena, descrições pornográficas, órgãos sexuais expostos, animação pornográfica, áudio pornográfico, vídeo pornográfico, criação de textos pornográficos ou conteúdo semelhante;',
                                    '2) Interação pornográfica e encenação de papéis: realizar conversas pornográficas, encenações pornográficas, descrições de fantasias sexuais, convites sexuais ou qualquer forma de interação sexual virtual por meio dos Serviços;',
                                    '3) Direcionamento para plataformas e recursos pornográficos: fornecer, publicar, promover ou direcionar o acesso a sites pornográficos, aplicativos pornográficos, links para recursos pornográficos, grupos sociais pornográficos ou outras plataformas de conteúdo adulto;',
                                    '4) Uso pornográfico com fins comerciais: usar os Serviços para produção, negociação, publicidade, captação de tráfego ou qualquer forma de atividade pornográfica comercial.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Conteúdo ilegal, infrator e prejudicial',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Você não poderá usar os Serviços para gerar, carregar, armazenar ou disseminar o seguinte conteúdo, nem praticar condutas relacionadas:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Conteúdo que viole leis e regulamentos: incluindo, entre outros, conteúdo que ameace a segurança nacional, subverta o poder do Estado, prejudique a unidade nacional, incite o ódio étnico ou promova terrorismo, extremismo ou separatismo;',
                                    '2) Conteúdo que infrinja os direitos e interesses legítimos de terceiros: incluindo, entre outros, o uso não autorizado de materiais protegidos por direitos autorais, marcas, patentes ou outros direitos de propriedade intelectual, ou conteúdo que viole direitos de imagem, privacidade, reputação, nome, segredos comerciais ou outros direitos;',
                                    '3) Conteúdo violento, de ódio ou discriminatório: conteúdo que ataque, insulte, ameace, assedie, discrimine ou incite à violência contra grupos ou indivíduos com base em raça, etnia, religião, gênero, orientação sexual, idade, condição física ou mental, nacionalidade, região ou outras características;',
                                    '4) Conteúdo falso, fraudulento ou enganoso: incluindo, entre outros, a criação de notícias falsas, falsificação de identidade, prática de fraudes, ataques de phishing, publicação de publicidade falsa ou informações comerciais enganosas;',
                                    '5) Abuso técnico: incluindo, entre outros, o envio de vírus, código malicioso ou cavalos de Troia, uso de rastreadores ou bots para acessar os Serviços em massa, exploração de falhas técnicas para contornar restrições do serviço, realização de ataques de negação de serviço ou outras condutas que prejudiquem o funcionamento normal dos Serviços.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Sua total responsabilidade pelo conteúdo de entrada e pelo conteúdo gerado',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Você entende e concorda que todo o conteúdo de entrada fornecido aos Serviços (incluindo, entre outros, instruções de texto, configurações de parâmetros, casos de referência, imagens, vídeos, áudios e modelos de design carregados etc.) deve ser legal, estar em conformidade e não infringir quaisquer direitos de terceiros. Você garante que detém direitos de propriedade intelectual completos e livres de vícios sobre tal conteúdo ou que obteve autorização legal.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Os Serviços geram o conteúdo correspondente com base na sua entrada (doravante denominado “Conteúdo Gerado”). Você assume total responsabilidade legal pelo Conteúdo Gerado, incluindo, entre outros, conformidade do conteúdo, violação de propriedade intelectual, violação de direitos da personalidade e riscos comerciais. Você deverá revisar, avaliar e modificar o Conteúdo Gerado por conta própria, conforme necessário, para garantir que ele não viole esta Política, o Contrato Principal ou quaisquer leis e regulamentos aplicáveis.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Responsabilidade pela publicação em plataformas de terceiros',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Se você publicar Conteúdo Gerado em plataformas de terceiros (como redes sociais, sistemas de publicidade, plataformas de comércio eletrônico etc.), deverá cumprir as regras dessas plataformas. Quaisquer penalidades, perdas ou disputas jurídicas decorrentes dessa publicação serão de sua exclusiva responsabilidade e não terão relação com esta plataforma.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Lembrete especial',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'O conteúdo gerado por IA pode estar sujeito a limitações técnicas, como dados de treinamento e lógica algorítmica, e não há garantia de que seja absolutamente preciso, inofensivo ou compatível com exigências legais específicas. Você não poderá alegar que o conteúdo foi “gerado por IA” para se eximir de sua própria responsabilidade legal.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Nossos direitos de supervisão e execução',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Temos o direito (mas não a obrigação) de supervisionar, revisar ou inspecionar o seu uso dos Serviços e o Conteúdo Gerado. Se descobrirmos ou recebermos uma denúncia razoável de que você, ou qualquer pessoa que utilize os Serviços por meio da sua conta, violou esta Política, poderemos, a nosso exclusivo critério, adotar uma ou mais das seguintes medidas sem aviso prévio:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Emitir uma advertência por escrito e exigir correção dentro de um prazo determinado;',
                            '2) Excluir, bloquear ou proibir o acesso ao conteúdo infrator;',
                            '3) Suspender ou encerrar total ou parcialmente o seu acesso aos Serviços;',
                            '4) Encerrar permanentemente a sua conta e proibir um novo cadastro;',
                            '5) Informar ou divulgar as informações da sua conta e os registros de uso às autoridades competentes, órgãos reguladores ou titulares de direitos relevantes;',
                            '6) Exigir sua responsabilidade por violação contratual ou infração de direitos, de acordo com a lei, incluindo, entre outros, exigir que você nos indenize e/ou indenize terceiros por todas as perdas sofridas em decorrência disso (incluindo, entre outros, custas judiciais, honorários advocatícios, indenizações etc.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'As medidas acima não afetam quaisquer outros direitos que possamos reivindicar nos termos do Contrato Principal ou de outros acordos relacionados.',
                    },
                ],
            },
            {
                title: '4. Canais de denúncia e reclamação',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Se, durante o uso dos Serviços, você identificar que qualquer usuário ou qualquer conteúdo pode violar esta Política (por exemplo, conteúdo pornográfico, conteúdo infrator ou outras violações), incentivamos você a nos denunciar ou apresentar uma reclamação por meio de um dos seguintes canais:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) E-mail: {email}',
                            '2) Atendimento ao cliente online: faça login na sua conta WeryAI, acesse a página de cobrança ou a central de ajuda, clique no botão de atendimento ao cliente e envie as informações relevantes',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Analisaremos o conteúdo denunciado dentro de um prazo razoável e adotaremos as medidas cabíveis de acordo com esta Política e com as leis e regulamentos aplicáveis. Observe que talvez não possamos responder individualmente a cada denúncia, mas nos comprometemos a tratar com seriedade cada denúncia válida.',
                    },
                ],
            },
            {
                title: '5. Atualizações e alterações desta Política',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Podemos revisar ou atualizar esta Política periodicamente com base no desenvolvimento do negócio, mudanças tecnológicas, exigências legais e regulatórias ou mudanças nas melhores práticas do setor. A Política atualizada será comunicada a você por um ou mais dos seguintes meios:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Publicação de um anúncio no site oficial da WeryAI (https://weryai.com);',
                            '2) Envio de uma notificação para o seu endereço de e-mail cadastrado;',
                            '3) Informação por meio de mensagens no site, pop-ups ou outros meios.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'A Política revisada entrará em vigor na data indicada no anúncio. Se você continuar usando os Serviços, isso significará que aceita e concorda em cumprir a Política atualizada; se não aceitar a atualização, interrompa o uso dos Serviços.',
                    },
                ],
            },
        ],
        seoDescription:
            'Política de Uso Aceitável da WeryAI descrevendo o conteúdo e as condutas proibidas, a responsabilidade do usuário, a supervisão e execução, os canais de denúncia e as atualizações da política.',
    },
    it: {
        title: 'Politica di uso accettabile di WeryAI',
        introTitle: 'Introduzione',
        intro: [
            'La presente Politica di uso accettabile (di seguito la “Politica”) costituisce parte integrante del Contratto di servizio WeryAI (di seguito il “Contratto principale”). Accedendo o utilizzando qualsiasi servizio fornito da WeryAI (inclusi, a titolo esemplificativo ma non esaustivo, la versione web, le applicazioni mobili e le relative funzionalità di generazione di contenuti tramite intelligenza artificiale, di seguito collettivamente i “Servizi”), l’utente (di seguito l’“Utente” o “tu”) accetta di rispettare tutti i termini della presente Politica.',
            'La presente Politica è finalizzata a vietare espressamente l’uso dei Servizi per generare, caricare, diffondere o conservare qualsiasi contenuto illegale, inappropriato o lesivo dei legittimi diritti e interessi altrui, in particolare pornografia, nudità, allusioni sessuali e altri comportamenti contrari all’ordine pubblico, al buon costume o alle leggi e normative applicabili. Se non accetti la presente Politica, interrompi immediatamente l’uso dei Servizi.',
        ],
        sections: [
            {
                title: '1. Contenuti e comportamenti vietati',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Durante l’utilizzo dei Servizi, non puoi, da solo o con altri, compiere alcuno dei seguenti atti, né aiutare, incoraggiare o indurre altri a compierli:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Contenuti pornografici, nudità e allusioni sessuali',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Vietiamo rigorosamente l’utilizzo dei Servizi per qualsiasi finalità connessa a pornografia, oscenità, nudità o allusioni sessuali, inclusi, a titolo esemplificativo ma non esaustivo:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Generazione o diffusione di contenuti pornografici: utilizzo dei Servizi per generare, caricare, condividere, mostrare o trasmettere qualsiasi contenuto che contenga o suggerisca atti sessuali, provocazione sessuale, allusioni sessuali, linguaggio osceno, descrizioni pornografiche, organi sessuali esposti, animazioni pornografiche, audio pornografici, video pornografici, testi pornografici o contenuti simili;',
                                    '2) Interazioni pornografiche e giochi di ruolo: svolgimento tramite i Servizi di chat pornografiche, giochi di ruolo pornografici, descrizioni di fantasie sessuali, inviti sessuali o qualsiasi forma di interazione sessuale virtuale;',
                                    '3) Indirizzamento verso piattaforme e risorse pornografiche: fornire, pubblicare, promuovere o indirizzare l’accesso a siti pornografici, applicazioni pornografiche, link a risorse pornografiche, gruppi social pornografici o altre piattaforme di contenuti per adulti;',
                                    '4) Uso pornografico a fini commerciali: utilizzo dei Servizi per la produzione, il commercio, la pubblicità, la generazione di traffico o qualsiasi forma di attività pornografica commerciale.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Contenuti illegali, lesivi dei diritti e dannosi',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Non puoi utilizzare i Servizi per generare, caricare, conservare o diffondere i seguenti contenuti né porre in essere condotte correlate:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Contenuti che violano leggi e regolamenti: inclusi, a titolo esemplificativo ma non esaustivo, contenuti che mettono in pericolo la sicurezza nazionale, sovvertono il potere statale, compromettono l’unità nazionale, incitano all’odio etnico o promuovono terrorismo, estremismo o separatismo;',
                                    '2) Contenuti che violano i legittimi diritti e interessi altrui: inclusi, a titolo esemplificativo ma non esaustivo, l’uso non autorizzato di materiali protetti da diritto d’autore, marchi, brevetti o altri diritti di proprietà intellettuale, oppure contenuti che violano il diritto all’immagine, la privacy, la reputazione, il nome, i segreti commerciali o altri diritti;',
                                    '3) Contenuti violenti, d’odio o discriminatori: contenuti che attaccano, insultano, minacciano, molestano, discriminano o incitano alla violenza contro gruppi o individui in base a razza, etnia, religione, genere, orientamento sessuale, età, condizione fisica o mentale, nazionalità, regione o altre caratteristiche;',
                                    '4) Contenuti falsi, fraudolenti o fuorvianti: inclusi, a titolo esemplificativo ma non esaustivo, la creazione di fake news, la falsificazione dell’identità, la realizzazione di frodi, attacchi di phishing, la pubblicazione di pubblicità false o di informazioni commerciali fuorvianti;',
                                    '5) Abusi tecnici: inclusi, a titolo esemplificativo ma non esaustivo, il caricamento di virus, codice dannoso o trojan, l’uso di crawler o bot per accedere ai Servizi in massa, lo sfruttamento di vulnerabilità tecniche per aggirare le limitazioni del servizio, la realizzazione di attacchi denial-of-service o altre condotte che compromettano il normale funzionamento dei Servizi.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. La tua piena responsabilità per il contenuto di input e il contenuto generato',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Comprendi e accetti che tutti i contenuti di input che fornisci ai Servizi (inclusi, a titolo esemplificativo ma non esaustivo, prompt testuali, impostazioni dei parametri, casi di riferimento, immagini, video, audio e modelli di design caricati, ecc.) devono essere leciti, conformi e non violare alcun diritto di terzi. Garantisci di detenere diritti di proprietà intellettuale completi e privi di vizi su tali contenuti oppure di aver ottenuto un’autorizzazione legale.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'I Servizi generano il contenuto corrispondente sulla base del tuo input (di seguito il “Contenuto generato”). Ti assumi la piena responsabilità legale per il Contenuto generato, inclusi, a titolo esemplificativo ma non esaustivo, la conformità del contenuto, la violazione della proprietà intellettuale, la violazione dei diritti della personalità e i rischi commerciali. Dovrai esaminare, valutare e modificare autonomamente il Contenuto generato, se necessario, per assicurarti che non violi la presente Politica, il Contratto principale o qualsiasi legge o regolamento applicabile.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Responsabilità per la pubblicazione su piattaforme di terzi',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Se pubblichi il Contenuto generato su piattaforme di terzi (come social media, sistemi pubblicitari, piattaforme di e-commerce, ecc.), devi rispettare le regole di tali piattaforme. Qualsiasi sanzione, perdita o controversia legale derivante da tale pubblicazione sarà esclusivamente a tuo carico e non avrà alcun rapporto con la nostra piattaforma.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Avvertenza speciale',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'I contenuti generati dall’IA possono essere soggetti a limitazioni tecniche, come i dati di addestramento e la logica algoritmica, e non è garantito che siano assolutamente accurati, innocui o conformi a specifici requisiti legali. Non puoi invocare il fatto che il contenuto sia stato “generato dall’IA” per sottrarti alla tua responsabilità legale.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. I nostri diritti di supervisione e applicazione',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Abbiamo il diritto (ma non l’obbligo) di supervisionare, esaminare o controllare il tuo utilizzo dei Servizi e il Contenuto generato. Se scopriamo o riceviamo una segnalazione ragionevole secondo cui tu, o qualsiasi persona che utilizzi i Servizi tramite il tuo account, hai violato la presente Politica, possiamo, a nostra esclusiva discrezione, adottare una o più delle seguenti misure senza preavviso:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Emetterti un avvertimento scritto e richiedere la correzione entro un termine determinato;',
                            '2) Eliminare, bloccare o vietare l’accesso al contenuto in violazione;',
                            '3) Sospendere o terminare in tutto o in parte il tuo accesso ai Servizi;',
                            '4) Chiudere permanentemente il tuo account e vietarti di registrarti nuovamente;',
                            '5) Segnalare o divulgare le informazioni del tuo account e i registri di utilizzo alle autorità competenti, agli organismi di regolamentazione o ai titolari dei diritti interessati;',
                            '6) Far valere la tua responsabilità per inadempimento contrattuale o violazione dei diritti ai sensi della legge, incluso, a titolo esemplificativo ma non esaustivo, richiederti il risarcimento di tutte le perdite subite da noi e/o da terzi di conseguenza (incluse, a titolo esemplificativo ma non esaustivo, spese processuali, onorari legali, risarcimenti, ecc.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Le misure di cui sopra non pregiudicano eventuali altri diritti che potremmo far valere ai sensi del Contratto principale o di altri accordi correlati.',
                    },
                ],
            },
            {
                title: '4. Canali di segnalazione e reclamo',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Se durante l’utilizzo dei Servizi rilevi che qualsiasi utente o contenuto potrebbe violare la presente Politica (ad esempio contenuti pornografici, contenuti che violano diritti o altre violazioni), ti invitiamo a segnalarcelo o a presentare un reclamo tramite uno dei seguenti canali:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) E-mail: {email}',
                            '2) Assistenza clienti online: accedi al tuo account WeryAI, vai alla pagina di fatturazione o al centro assistenza, fai clic sul pulsante del servizio clienti e invia le informazioni pertinenti',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Esamineremo il contenuto segnalato entro un termine ragionevole e adotteremo le misure appropriate in conformità con la presente Politica e con le leggi e normative applicabili. Tieni presente che potremmo non essere in grado di rispondere individualmente a ogni segnalazione, ma ci impegniamo a trattare seriamente ogni segnalazione valida.',
                    },
                ],
            },
            {
                title: '5. Aggiornamenti e modifiche della presente Politica',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Possiamo rivedere o aggiornare periodicamente la presente Politica in base allo sviluppo dell’attività, ai cambiamenti tecnologici, ai requisiti legali e normativi o ai cambiamenti nelle migliori pratiche del settore. La Politica aggiornata ti sarà comunicata tramite uno o più dei seguenti mezzi:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Pubblicazione di un annuncio sul sito ufficiale di WeryAI (https://weryai.com);',
                            '2) Invio di una notifica al tuo indirizzo e-mail registrato;',
                            '3) Comunicazione tramite messaggi sul sito, finestre pop-up o altri mezzi.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'La Politica rivista entrerà in vigore alla data di efficacia indicata nell’annuncio. Se continui a utilizzare i Servizi, ciò significa che accetti e ti impegni a rispettare la Politica aggiornata; se non accetti l’aggiornamento, interrompi l’utilizzo dei Servizi.',
                    },
                ],
            },
        ],
        seoDescription:
            'Politica di uso accettabile di WeryAI che descrive i contenuti e i comportamenti vietati, la responsabilità dell’utente, la supervisione e l’applicazione, i canali di segnalazione e gli aggiornamenti della politica.',
    },
    ar: {
        title: 'سياسة الاستخدام المقبول الخاصة بـ WeryAI',
        introTitle: 'مقدمة',
        intro: [
            'تشكل سياسة الاستخدام المقبول هذه (المشار إليها فيما يلي بـ "هذه السياسة") جزءا لا يتجزأ من اتفاقية خدمات WeryAI (المشار إليها فيما يلي بـ "الاتفاقية الرئيسية"). ومن خلال الوصول إلى أي من الخدمات التي تقدمها WeryAI أو استخدامها (بما في ذلك على سبيل المثال لا الحصر نسخة الويب، وتطبيقات الهاتف المحمول، والوظائف ذات الصلة الخاصة بتوليد المحتوى بالذكاء الاصطناعي، ويشار إليها مجتمعة فيما يلي بـ "الخدمات")، فإنك (المشار إليك فيما يلي بـ "المستخدم" أو "أنت") توافق على الالتزام بجميع أحكام هذه السياسة.',
            'تهدف هذه السياسة إلى الحظر الصريح لاستخدام الخدمات لإنشاء أو تحميل أو نشر أو تخزين أي محتوى غير قانوني أو غير لائق أو يضر بالحقوق والمصالح المشروعة للغير، وخاصة المحتوى الإباحي، والعري، والتلميحات الجنسية، وغيرها من السلوكيات التي تنتهك النظام العام أو الآداب العامة أو القوانين واللوائح المعمول بها. إذا كنت لا تقبل هذه السياسة، فيرجى التوقف فورا عن استخدام الخدمات.',
        ],
        sections: [
            {
                title: '1. المحتوى والسلوكيات المحظورة',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'أثناء استخدامك للخدمات، لا يجوز لك، بمفردك أو بالاشتراك مع الآخرين، الانخراط في أي من الأفعال التالية، كما لا يجوز لك مساعدة الآخرين أو تشجيعهم أو تحريضهم على القيام بها:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 المحتوى الإباحي والعري والتلميحات الجنسية',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'نحن نحظر بشكل صارم استخدام الخدمات لأي غرض يتعلق بالإباحية أو الفحش أو العري أو التلميحات الجنسية، بما في ذلك على سبيل المثال لا الحصر:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) إنشاء أو نشر محتوى إباحي: استخدام الخدمات لإنشاء أو تحميل أو مشاركة أو عرض أو نقل أي محتوى يتضمن أو يوحي بأفعال جنسية، أو إثارة جنسية، أو تلميحات جنسية، أو لغة بذيئة، أو أوصاف إباحية، أو أعضاء جنسية مكشوفة، أو رسوم متحركة إباحية، أو صوتيات إباحية، أو مقاطع فيديو إباحية، أو كتابة نصوص إباحية أو أي محتوى مماثل؛',
                                    '2) التفاعل الإباحي ولعب الأدوار: إجراء محادثات إباحية، أو لعب أدوار إباحية، أو وصف تخيلات جنسية، أو دعوات جنسية، أو أي شكل من أشكال التفاعل الجنسي الافتراضي من خلال الخدمات؛',
                                    '3) التوجيه إلى منصات وموارد إباحية: توفير أو نشر أو الترويج أو توجيه الوصول إلى أي مواقع إباحية أو تطبيقات إباحية أو روابط لموارد إباحية أو مجموعات اجتماعية إباحية أو منصات أخرى لمحتوى البالغين؛',
                                    '4) الاستخدام الإباحي التجاري: استخدام الخدمات لإنتاج محتوى إباحي أو تداوله أو الإعلان عنه أو جذب الزيارات له أو ممارسة أي نشاط إباحي تجاري بأي شكل.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 المحتوى غير القانوني والمنتهك للحقوق والضار',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'لا يجوز لك استخدام الخدمات لإنشاء أو تحميل أو تخزين أو نشر المحتوى التالي أو الانخراط في سلوكيات ذات صلة به:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) المحتوى الذي ينتهك القوانين واللوائح: بما في ذلك على سبيل المثال لا الحصر المحتوى الذي يهدد الأمن القومي، أو يقوض سلطة الدولة، أو يضر بالوحدة الوطنية، أو يحرض على الكراهية العرقية، أو يروج للإرهاب أو التطرف أو الانفصالية؛',
                                    '2) المحتوى الذي ينتهك الحقوق والمصالح المشروعة للغير: بما في ذلك على سبيل المثال لا الحصر الاستخدام غير المصرح به لمواد محمية بحقوق الطبع والنشر أو العلامات التجارية أو براءات الاختراع أو غيرها من حقوق الملكية الفكرية، أو المحتوى الذي ينتهك حقوق الصورة أو الخصوصية أو السمعة أو الاسم أو الأسرار التجارية أو غيرها من الحقوق؛',
                                    '3) المحتوى العنيف أو الذي يحض على الكراهية أو التمييز: المحتوى الذي يهاجم أو يهين أو يهدد أو يضايق أو يميز ضد أو يحرض على العنف ضد جماعات أو أفراد بسبب العرق أو الأصل الإثني أو الدين أو الجنس أو التوجه الجنسي أو العمر أو الحالة الجسدية أو النفسية أو الجنسية أو المنطقة أو غيرها من الخصائص؛',
                                    '4) المحتوى الزائف أو الاحتيالي أو المضلل: بما في ذلك على سبيل المثال لا الحصر إنشاء أخبار كاذبة، أو انتحال الهوية، أو تنفيذ عمليات احتيال، أو هجمات التصيد الاحتيالي، أو نشر إعلانات كاذبة أو معلومات تجارية مضللة؛',
                                    '5) الإساءة التقنية: بما في ذلك على سبيل المثال لا الحصر تحميل الفيروسات أو الأكواد الضارة أو أحصنة طروادة، أو استخدام برامج الزحف أو الروبوتات للوصول الجماعي إلى الخدمات، أو استغلال الثغرات التقنية لتجاوز قيود الخدمة، أو تنفيذ هجمات حجب الخدمة، أو غير ذلك من السلوكيات التي تعطل التشغيل الطبيعي للخدمات.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. مسؤوليتك الكاملة عن محتوى الإدخال والمحتوى الناتج',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'أنت تدرك وتوافق على أن جميع محتويات الإدخال التي تقدمها إلى الخدمات (بما في ذلك على سبيل المثال لا الحصر الأوامر النصية، وإعدادات المعلمات، والحالات المرجعية، والصور ومقاطع الفيديو والملفات الصوتية والقوالب التصميمية التي يتم تحميلها، وغيرها) يجب أن تكون قانونية ومتوافقة وألا تنتهك أي حقوق لطرف ثالث. كما تضمن أنك تمتلك حقوق ملكية فكرية كاملة وخالية من العيوب في هذا المحتوى أو أنك حصلت على تصريح قانوني.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'تقوم الخدمات بإنشاء المحتوى المقابل بناء على مدخلاتك (المشار إليه فيما يلي بـ "المحتوى الناتج"). وتتحمل أنت المسؤولية القانونية الكاملة عن المحتوى الناتج، بما في ذلك على سبيل المثال لا الحصر مدى توافق المحتوى، وانتهاك الملكية الفكرية، وانتهاك الحقوق الشخصية، والمخاطر التجارية. ويجب عليك مراجعة المحتوى الناتج وتقييمه وتعديله ذاتيا عند الضرورة لضمان عدم مخالفته لهذه السياسة أو الاتفاقية الرئيسية أو أي قوانين ولوائح معمول بها.',
                            },
                        ],
                    },
                    {
                        title: '2.3 مسؤولية النشر على منصات الأطراف الثالثة',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'إذا قمت بنشر المحتوى الناتج على منصات أطراف ثالثة (مثل وسائل التواصل الاجتماعي أو أنظمة الإعلانات أو منصات التجارة الإلكترونية وغيرها)، فيجب عليك الالتزام بقواعد تلك المنصات. وأي عقوبات أو خسائر أو نزاعات قانونية تنشأ عن هذا النشر تقع على عاتقك وحدك ولا علاقة لها بهذه المنصة.',
                            },
                        ],
                    },
                    {
                        title: '2.4 تذكير خاص',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'قد يخضع المحتوى الذي يتم إنشاؤه بواسطة الذكاء الاصطناعي لقيود تقنية مثل بيانات التدريب والمنطق الخوارزمي، ولا يوجد ضمان بأنه سيكون دقيقا تماما أو غير ضار أو متوافقا مع متطلبات قانونية محددة. ولا يجوز لك الاحتجاج بأن المحتوى "تم إنشاؤه بواسطة الذكاء الاصطناعي" للإعفاء من مسؤوليتك القانونية الخاصة.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. حقوقنا في الإشراف والتنفيذ',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'لدينا الحق (ولكن ليس الالتزام) في الإشراف على استخدامك للخدمات والمحتوى الناتج أو مراجعته أو فحصه. وإذا اكتشفنا أو تلقينا بلاغا معقولا يفيد بأنك، أو أي شخص يستخدم الخدمات من خلال حسابك، قد انتهك هذه السياسة، فيجوز لنا، وفقا لتقديرنا الخاص، اتخاذ واحد أو أكثر من التدابير التالية دون إشعار مسبق:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) إصدار تحذير كتابي لك والمطالبة بالتصحيح خلال مهلة محددة؛',
                            '2) حذف المحتوى المخالف أو حجبه أو منع الوصول إليه؛',
                            '3) تعليق أو إنهاء كل أو جزء من وصولك إلى الخدمات؛',
                            '4) إغلاق حسابك نهائيا ومنعك من إعادة التسجيل؛',
                            '5) الإبلاغ عن معلومات حسابك وسجلات الاستخدام الخاصة بك أو الكشف عنها للجهات المختصة بإنفاذ القانون أو الجهات التنظيمية أو أصحاب الحقوق المعنيين؛',
                            '6) مطالبتك بتحمل المسؤولية عن الإخلال بالعقد أو انتهاك الحقوق وفقا للقانون، بما في ذلك على سبيل المثال لا الحصر مطالبتك بتعويضنا و/أو تعويض الأطراف الثالثة عن جميع الخسائر التي تكبدوها نتيجة لذلك (بما في ذلك على سبيل المثال لا الحصر رسوم التقاضي وأتعاب المحاماة والتعويضات وغيرها).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'لا تؤثر التدابير المذكورة أعلاه على أي حقوق أخرى قد نطالب بها بموجب الاتفاقية الرئيسية أو غيرها من الاتفاقيات ذات الصلة.',
                    },
                ],
            },
            {
                title: '4. قنوات الإبلاغ والشكاوى',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'إذا اكتشفت أثناء استخدامك للخدمات أن أي مستخدم أو أي محتوى قد ينتهك هذه السياسة (على سبيل المثال، محتوى إباحي، أو محتوى ينتهك الحقوق، أو أي مخالفات أخرى)، فإننا نشجعك على إبلاغنا أو تقديم شكوى عبر إحدى الطرق التالية:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) البريد الإلكتروني: {email}',
                            '2) خدمة العملاء عبر الإنترنت: سجّل الدخول إلى حسابك في WeryAI، ثم انتقل إلى صفحة الفوترة أو مركز المساعدة، واضغط على زر خدمة العملاء، ثم أرسل المعلومات ذات الصلة',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'سنراجع المحتوى المبلغ عنه خلال فترة زمنية معقولة ونتخذ الإجراءات المناسبة وفقا لهذه السياسة والقوانين واللوائح المعمول بها. يرجى ملاحظة أننا قد لا نتمكن من الرد بشكل فردي على كل بلاغ، إلا أننا نتعهد بالتعامل بجدية مع كل بلاغ صالح.',
                    },
                ],
            },
            {
                title: '5. تحديثات وتعديلات هذه السياسة',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'يجوز لنا مراجعة هذه السياسة أو تحديثها من وقت لآخر استنادا إلى تطور الأعمال أو التغيرات التقنية أو المتطلبات القانونية والتنظيمية أو التغيرات في أفضل ممارسات الصناعة. وسيتم إخطارك بالسياسة المحدثة من خلال واحدة أو أكثر من الطرق التالية:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) نشر إعلان على الموقع الرسمي لـ WeryAI (https://weryai.com)؛',
                            '2) إرسال إشعار إلى عنوان بريدك الإلكتروني المسجل؛',
                            '3) الإبلاغ من خلال الرسائل داخل الموقع أو النوافذ المنبثقة أو وسائل أخرى.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'تدخل السياسة المعدلة حيز النفاذ في التاريخ المحدد في الإعلان. وإذا واصلت استخدام الخدمات، فهذا يعني أنك تقبل السياسة المحدثة وتوافق على الالتزام بها؛ وإذا لم تقبل التحديث، فيرجى التوقف عن استخدام الخدمات.',
                    },
                ],
            },
        ],
        seoDescription:
            'سياسة الاستخدام المقبول الخاصة بـ WeryAI التي توضح المحتوى والسلوكيات المحظورة، ومسؤولية المستخدم، والإشراف والتنفيذ، وقنوات الإبلاغ، وتحديثات السياسة.',
    },
    th: {
        title: 'นโยบายการใช้งานที่ยอมรับได้ของ WeryAI',
        introTitle: 'บทนำ',
        intro: [
            'นโยบายการใช้งานที่ยอมรับได้นี้ (ต่อไปนี้เรียกว่า "นโยบายนี้") เป็นส่วนหนึ่งของข้อตกลงการให้บริการของ WeryAI (ต่อไปนี้เรียกว่า "ข้อตกลงหลัก") เมื่อคุณ (ต่อไปนี้เรียกว่า "ผู้ใช้" หรือ "คุณ") เข้าถึงหรือใช้บริการใดๆ ที่ WeryAI ให้บริการ (รวมถึงแต่ไม่จำกัดเพียงเวอร์ชันเว็บ แอปพลิเคชันมือถือ และฟังก์ชันที่เกี่ยวข้องกับการสร้างเนื้อหาด้วยปัญญาประดิษฐ์ ซึ่งต่อไปนี้เรียกรวมว่า "บริการ") ให้ถือว่าคุณยอมรับและตกลงที่จะปฏิบัติตามข้อกำหนดทั้งหมดของนโยบายนี้',
            'นโยบายนี้มีวัตถุประสงค์เพื่อห้ามอย่างชัดเจนไม่ให้ใช้บริการเพื่อสร้าง อัปโหลด เผยแพร่ หรือจัดเก็บเนื้อหาที่ผิดกฎหมาย ไม่เหมาะสม หรือเป็นการละเมิดสิทธิและผลประโยชน์อันชอบด้วยกฎหมายของผู้อื่น โดยเฉพาะอย่างยิ่งเนื้อหาลามก อนาจาร การเปลือยกาย การสื่อความหมายทางเพศ และพฤติกรรมอื่นใดที่ขัดต่อความสงบเรียบร้อย ศีลธรรมอันดี หรือกฎหมายและข้อบังคับที่ใช้บังคับ หากคุณไม่ยอมรับนโยบายนี้ โปรดหยุดใช้บริการทันที',
        ],
        sections: [
            {
                title: '1. เนื้อหาและพฤติกรรมที่ห้าม',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'ในการใช้บริการ คุณต้องไม่กระทำการใดๆ ต่อไปนี้ ไม่ว่าจะโดยลำพังหรือร่วมกับผู้อื่น และต้องไม่ช่วยเหลือ สนับสนุน หรือชักจูงให้ผู้อื่นกระทำการดังกล่าว:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 เนื้อหาลามก การเปลือยกาย และการสื่อความหมายทางเพศ',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'เราห้ามอย่างเคร่งครัดไม่ให้ใช้บริการเพื่อวัตถุประสงค์ใดๆ ที่เกี่ยวข้องกับสื่อลามก อนาจาร การเปลือยกาย หรือการสื่อความหมายทางเพศ รวมถึงแต่ไม่จำกัดเพียง:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) การสร้างหรือเผยแพร่เนื้อหาลามก: ใช้บริการเพื่อสร้าง อัปโหลด แบ่งปัน แสดง หรือส่งต่อเนื้อหาใดๆ ที่มีหรือสื่อถึงพฤติกรรมทางเพศ การยั่วยวนทางเพศ การสื่อความหมายทางเพศ ภาษาหยาบคาย คำบรรยายลามก อวัยวะเพศที่เปิดเผย อนิเมชันลามก เสียงลามก วิดีโอลามก งานเขียนเชิงลามก หรือเนื้อหาที่มีลักษณะคล้ายกัน;',
                                    '2) ปฏิสัมพันธ์ลามกและการสวมบทบาท: ดำเนินการสนทนาลามก การสวมบทบาทลามก การบรรยายจินตนาการทางเพศ การเชิญชวนทางเพศ หรือปฏิสัมพันธ์ทางเพศเสมือนทุกรูปแบบผ่านบริการ;',
                                    '3) การชี้นำไปยังแพลตฟอร์มและทรัพยากรลามก: ให้บริการ เผยแพร่ โปรโมต หรือชี้นำให้เข้าถึงเว็บไซต์ลามก แอปพลิเคชันลามก ลิงก์ทรัพยากรลามก กลุ่มสังคมลามก หรือแพลตฟอร์มเนื้อหาสำหรับผู้ใหญ่ประเภทอื่น;',
                                    '4) การใช้ในเชิงพาณิชย์เกี่ยวกับสื่อลามก: ใช้บริการเพื่อผลิต ซื้อขาย โฆษณา ดึงทราฟฟิก หรือดำเนินกิจกรรมลามกเชิงพาณิชย์ในรูปแบบใดๆ',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 เนื้อหาที่ผิดกฎหมาย ละเมิดสิทธิ และเป็นอันตราย',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'คุณต้องไม่ใช้บริการเพื่อสร้าง อัปโหลด จัดเก็บ หรือเผยแพร่เนื้อหาต่อไปนี้ หรือมีพฤติกรรมที่เกี่ยวข้อง:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) เนื้อหาที่ละเมิดกฎหมายและข้อบังคับ: รวมถึงแต่ไม่จำกัดเพียงเนื้อหาที่เป็นอันตรายต่อความมั่นคงของชาติ โค่นล้มอำนาจรัฐ บ่อนทำลายเอกภาพของชาติ ยุยงให้เกิดความเกลียดชังทางชาติพันธุ์ หรือสนับสนุนการก่อการร้าย ลัทธิสุดโต่ง หรือการแบ่งแยกดินแดน;',
                                    '2) เนื้อหาที่ละเมิดสิทธิและผลประโยชน์อันชอบด้วยกฎหมายของผู้อื่น: รวมถึงแต่ไม่จำกัดเพียงการใช้โดยไม่ได้รับอนุญาตซึ่งสื่อที่มีลิขสิทธิ์ เครื่องหมายการค้า สิทธิบัตร หรือทรัพย์สินทางปัญญาอื่นของผู้อื่น หรือเนื้อหาที่ละเมิดสิทธิในภาพลักษณ์ สิทธิความเป็นส่วนตัว สิทธิในชื่อเสียง สิทธิในชื่อ ความลับทางการค้า หรือสิทธิอื่นๆ;',
                                    '3) เนื้อหาความรุนแรง ความเกลียดชัง หรือการเลือกปฏิบัติ: เนื้อหาที่โจมตี ดูหมิ่น ข่มขู่ คุกคาม เลือกปฏิบัติ หรือปลุกปั่นให้เกิดความรุนแรงต่อกลุ่มหรือบุคคลตามเชื้อชาติ ชาติพันธุ์ ศาสนา เพศ รสนิยมทางเพศ อายุ สภาพร่างกายหรือจิตใจ สัญชาติ ภูมิภาค หรือคุณลักษณะอื่น;',
                                    '4) เนื้อหาเท็จ หลอกลวง หรือทำให้เข้าใจผิด: รวมถึงแต่ไม่จำกัดเพียงการสร้างข่าวปลอม การปลอมแปลงตัวตน การฉ้อโกง การโจมตีแบบฟิชชิง การเผยแพร่โฆษณาเท็จ หรือข้อมูลทางการค้าที่ทำให้เข้าใจผิด;',
                                    '5) การใช้เทคโนโลยีในทางที่ผิด: รวมถึงแต่ไม่จำกัดเพียงการอัปโหลดไวรัส โค้ดอันตราย หรือโทรจัน การใช้โปรแกรมรวบรวมข้อมูลหรือบอตเพื่อเข้าถึงบริการเป็นจำนวนมาก การใช้ช่องโหว่ทางเทคนิคเพื่อหลีกเลี่ยงข้อจำกัดของบริการ การโจมตีแบบปฏิเสธการให้บริการ หรือพฤติกรรมอื่นใดที่ทำลายการทำงานตามปกติของบริการ',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. ความรับผิดชอบทั้งหมดของคุณต่อเนื้อหาที่ป้อนเข้าและเนื้อหาที่สร้างขึ้น',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'คุณเข้าใจและยอมรับว่าเนื้อหาที่ป้อนเข้าทั้งหมดที่คุณให้แก่บริการ (รวมถึงแต่ไม่จำกัดเพียงคำสั่งข้อความ การตั้งค่าพารามิเตอร์ กรณีอ้างอิง รูปภาพ วิดีโอ เสียง และเทมเพลตการออกแบบที่อัปโหลด ฯลฯ) จะต้องชอบด้วยกฎหมาย เป็นไปตามข้อกำหนด และไม่ละเมิดสิทธิของบุคคลที่สามใดๆ คุณรับประกันว่าคุณมีสิทธิในทรัพย์สินทางปัญญาที่ครบถ้วนและปราศจากข้อบกพร่องในเนื้อหาดังกล่าว หรือได้รับอนุญาตโดยชอบด้วยกฎหมายแล้ว',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'บริการจะสร้างเนื้อหาที่เกี่ยวข้องตามข้อมูลที่คุณป้อนเข้า (ต่อไปนี้เรียกว่า "เนื้อหาที่สร้างขึ้น") คุณต้องรับผิดชอบทางกฎหมายทั้งหมดต่อเนื้อหาที่สร้างขึ้น รวมถึงแต่ไม่จำกัดเพียงความสอดคล้องของเนื้อหา การละเมิดทรัพย์สินทางปัญญา การละเมิดสิทธิส่วนบุคคล และความเสี่ยงทางการค้า คุณควรตรวจสอบ ประเมิน และแก้ไขเนื้อหาที่สร้างขึ้นด้วยตนเองตามความจำเป็น เพื่อให้แน่ใจว่าเนื้อหาดังกล่าวไม่ขัดต่อนโยบายนี้ ข้อตกลงหลัก หรือกฎหมายและข้อบังคับที่ใช้บังคับใดๆ',
                            },
                        ],
                    },
                    {
                        title: '2.3 ความรับผิดชอบในการเผยแพร่บนแพลตฟอร์มของบุคคลที่สาม',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'หากคุณเผยแพร่เนื้อหาที่สร้างขึ้นบนแพลตฟอร์มของบุคคลที่สาม (เช่น โซเชียลมีเดีย ระบบโฆษณา แพลตฟอร์มอีคอมเมิร์ซ เป็นต้น) คุณต้องปฏิบัติตามกฎของแพลตฟอร์มนั้น บทลงโทษ ความสูญเสีย หรือข้อพิพาททางกฎหมายใดๆ ที่เกิดจากการเผยแพร่ดังกล่าวเป็นความรับผิดชอบของคุณแต่เพียงผู้เดียว และไม่เกี่ยวข้องกับแพลตฟอร์มนี้',
                            },
                        ],
                    },
                    {
                        title: '2.4 ข้อเตือนใจพิเศษ',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'เนื้อหาที่สร้างโดย AI อาจอยู่ภายใต้ข้อจำกัดทางเทคนิค เช่น ข้อมูลการฝึกและตรรกะของอัลกอริทึม และไม่ได้รับประกันว่าถูกต้องสมบูรณ์ ปลอดภัย หรือเป็นไปตามข้อกำหนดทางกฎหมายเฉพาะเสมอไป คุณไม่อาจอ้างว่าเนื้อหานั้น "สร้างโดย AI" เพื่อขอยกเว้นความรับผิดชอบทางกฎหมายของตนเองได้',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. สิทธิของเราในการกำกับดูแลและบังคับใช้',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'เรามีสิทธิ (แต่ไม่ใช่หน้าที่) ในการกำกับดูแล ตรวจสอบ หรือสุ่มตรวจการใช้บริการและเนื้อหาที่สร้างขึ้นของคุณ หากเราพบหรือได้รับรายงานอันมีเหตุผลว่า คุณหรือบุคคลใดก็ตามที่ใช้บริการผ่านบัญชีของคุณได้ละเมิดนโยบายนี้ เราอาจใช้ดุลยพินิจของเราเองในการดำเนินมาตรการอย่างใดอย่างหนึ่งหรือหลายอย่างดังต่อไปนี้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) ออกคำเตือนเป็นลายลักษณ์อักษรและกำหนดให้แก้ไขภายในระยะเวลาที่กำหนด;',
                            '2) ลบ ปิดกั้น หรือห้ามการเข้าถึงเนื้อหาที่ละเมิด;',
                            '3) ระงับหรือยุติการเข้าถึงบริการทั้งหมดหรือบางส่วนของคุณ;',
                            '4) ปิดบัญชีของคุณอย่างถาวรและห้ามสมัครใหม่;',
                            '5) รายงานหรือเปิดเผยข้อมูลบัญชีและบันทึกการใช้งานของคุณต่อหน่วยงานบังคับใช้กฎหมาย หน่วยงานกำกับดูแล หรือผู้ทรงสิทธิที่เกี่ยวข้อง;',
                            '6) ดำเนินการให้คุณรับผิดจากการผิดสัญญาหรือการละเมิดสิทธิ์ตามกฎหมาย รวมถึงแต่ไม่จำกัดเพียงการเรียกร้องให้คุณชดใช้ความเสียหายทั้งหมดที่เราและ/หรือบุคคลที่สามได้รับอันเป็นผลจากการกระทำดังกล่าว (รวมถึงแต่ไม่จำกัดเพียงค่าดำเนินคดี ค่าทนายความ ค่าเสียหาย เป็นต้น)',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'มาตรการข้างต้นไม่กระทบต่อสิทธิอื่นใดที่เราอาจเรียกร้องได้ตามข้อตกลงหลักหรือข้อตกลงอื่นที่เกี่ยวข้อง',
                    },
                ],
            },
            {
                title: '4. ช่องทางการรายงานและร้องเรียน',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'หากในระหว่างการใช้บริการ คุณพบว่าผู้ใช้รายใดหรือเนื้อหาใดอาจละเมิดนโยบายนี้ (เช่น เนื้อหาลามก เนื้อหาที่ละเมิดสิทธิ หรือการละเมิดอื่นๆ) เราขอแนะนำให้คุณรายงานหรือยื่นเรื่องร้องเรียนกับเราผ่านช่องทางดังต่อไปนี้:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) อีเมล: {email}',
                            '2) บริการลูกค้าออนไลน์: เข้าสู่ระบบบัญชี WeryAI ของคุณ ไปที่หน้าการเรียกเก็บเงินหรือศูนย์ช่วยเหลือ คลิกปุ่มบริการลูกค้า และส่งข้อมูลที่เกี่ยวข้อง',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'เราจะตรวจสอบเนื้อหาที่ถูกรายงานภายในระยะเวลาอันสมควร และดำเนินมาตรการที่เหมาะสมตามนโยบายนี้และกฎหมายกับข้อบังคับที่ใช้บังคับ โปรดทราบว่าเราอาจไม่สามารถตอบกลับเป็นรายบุคคลต่อทุกการรายงานได้ แต่เราขอให้คำมั่นว่าจะให้ความสำคัญกับทุกการรายงานที่มีมูลอย่างจริงจัง',
                    },
                ],
            },
            {
                title: '5. การอัปเดตและการแก้ไขนโยบายนี้',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'เราอาจปรับปรุงหรือแก้ไขนโยบายนี้เป็นระยะตามการพัฒนาธุรกิจ การเปลี่ยนแปลงทางเทคโนโลยี ข้อกำหนดทางกฎหมายและข้อกำกับดูแล หรือการเปลี่ยนแปลงของแนวปฏิบัติที่ดีที่สุดในอุตสาหกรรม โดยนโยบายที่อัปเดตแล้วจะแจ้งให้คุณทราบผ่านหนึ่งหรือหลายวิธีดังต่อไปนี้:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) การประกาศบนเว็บไซต์ทางการของ WeryAI (https://weryai.com);',
                            '2) การส่งการแจ้งเตือนไปยังอีเมลที่คุณลงทะเบียนไว้;',
                            '3) การแจ้งผ่านข้อความภายในเว็บไซต์ หน้าต่างป๊อปอัป หรือวิธีการอื่นๆ',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'นโยบายที่แก้ไขแล้วจะมีผลใช้บังคับตั้งแต่วันที่มีผลตามที่ระบุไว้ในประกาศ หากคุณยังคงใช้บริการต่อไป จะถือว่าคุณยอมรับและตกลงที่จะปฏิบัติตามนโยบายที่อัปเดตแล้ว หากคุณไม่ยอมรับการอัปเดต โปรดหยุดใช้บริการ',
                    },
                ],
            },
        ],
        seoDescription:
            'นโยบายการใช้งานที่ยอมรับได้ของ WeryAI ที่อธิบายเนื้อหาและพฤติกรรมที่ห้าม ความรับผิดชอบของผู้ใช้ การกำกับดูแลและบังคับใช้ ช่องทางการรายงาน และการอัปเดตนโยบาย',
    },
    da: {
        title: 'WeryAIs politik for acceptabel brug',
        introTitle: 'Introduktion',
        intro: [
            'Denne politik for acceptabel brug (herefter "denne politik") er en integreret del af WeryAIs serviceaftale (herefter "hovedaftalen"). Ved at få adgang til eller bruge nogen af de tjenester, der leveres af WeryAI (herunder, men ikke begrænset til, webversionen, mobilapplikationer og relaterede funktioner til AI-generering af indhold, samlet benaevnt "tjenesterne"), accepterer du (herefter "brugeren" eller "du") at overholde alle vilkår i denne politik.',
            'Formålet med denne politik er udtrykkeligt at forbyde brugen af tjenesterne til at generere, uploade, distribuere eller lagre indhold, der er ulovligt, upassende eller skader andres lovlige rettigheder og interesser, især pornografisk indhold, nøgenhed, seksuelle hentydninger og anden adfærd, der strider mod offentlig orden, sædelighed eller gældende love og regler. Hvis du ikke accepterer denne politik, skal du straks ophøre med at bruge tjenesterne.',
        ],
        sections: [
            {
                title: '1. Forbudt indhold og adfærd',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Under din brug af tjenesterne må du hverken alene eller sammen med andre udføre nogen af følgende handlinger, og du må heller ikke hjælpe, opmuntre eller tilskynde andre til at gøre det:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Pornografisk indhold, nøgenhed og seksuelle hentydninger',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Vi forbyder strengt brugen af tjenesterne til ethvert formål relateret til pornografi, obskønt indhold, nøgenhed eller seksuelle hentydninger, herunder, men ikke begrænset til:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Generering eller spredning af pornografisk indhold: brug af tjenesterne til at generere, uploade, dele, vise eller overføre indhold, der indeholder eller antyder seksuelle handlinger, seksuel provokation, seksuelle hentydninger, obskønt sprog, pornografiske beskrivelser, blotlagte kønsorganer, pornografisk animation, pornografisk lyd, pornografisk video, pornografisk tekstproduktion eller lignende indhold;',
                                    '2) Pornografisk interaktion og rollespil: gennemføre pornografiske chats, pornografisk rollespil, beskrivelser af seksuelle fantasier, seksuelle invitationer eller enhver form for virtuel seksuel interaktion gennem tjenesterne;',
                                    '3) Henvisning til pornografiske platforme og ressourcer: levere, offentliggøre, promovere eller henvise adgang til pornografiske websites, pornografiske apps, links til pornografiske ressourcer, pornografiske sociale grupper eller andre platforme med voksenindhold;',
                                    '4) Kommerciel pornografisk anvendelse: bruge tjenesterne til produktion, handel, annoncering, trafikkapring eller enhver form for kommerciel pornografisk aktivitet.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Ulovligt, krænkende og skadeligt indhold',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Du må ikke bruge tjenesterne til at generere, uploade, lagre eller sprede følgende indhold eller udøve relateret adfærd:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Indhold, der overtraeder love og regler: herunder, men ikke begrænset til, indhold der bringer national sikkerhed i fare, undergraver statsmagten, skader national enhed, tilskynder til etnisk had eller promoverer terrorisme, ekstremisme eller separatistiske formål;',
                                    '2) Indhold, der kraenker andres lovlige rettigheder og interesser: herunder, men ikke begrænset til, uautoriseret brug af materiale beskyttet af ophavsret, varemærker, patenter eller andre immaterielle rettigheder, eller indhold der kraenker billedrettigheder, privatliv, omdømme, navnerettigheder, forretningshemmeligheder eller andre rettigheder;',
                                    '3) Voldeligt, hadefuldt eller diskriminerende indhold: indhold der angriber, fornærmer, truer, chikanerer, diskriminerer eller opfordrer til vold mod grupper eller enkeltpersoner på baggrund af race, etnicitet, religion, køn, seksuel orientering, alder, fysisk eller mental tilstand, nationalitet, region eller andre karakteristika;',
                                    '4) Falsk, svigagtigt eller vildledende indhold: herunder, men ikke begrænset til, fremstilling af falske nyheder, identitetsforfalskning, bedrageri, phishing-angreb, offentliggørelse af falsk reklame eller vildledende kommerciel information;',
                                    '5) Teknisk misbrug: herunder, men ikke begrænset til, upload af virus, skadelig kode eller trojanere, brug af crawlere eller bots til masseadgang til tjenesterne, udnyttelse af tekniske sårbarheder til at omgå servicebegrænsninger, gennemførelse af denial-of-service-angreb eller anden adfærd, der forstyrrer den normale drift af tjenesterne.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Dit fulde ansvar for inputindhold og genereret indhold',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Du forstår og accepterer, at alt inputindhold, du leverer til tjenesterne (herunder, men ikke begrænset til, tekstprompter, parameterindstillinger, referencesager, uploadede billeder, videoer, lyd og designtemplates osv.), skal være lovligt, i overensstemmelse med reglerne og må ikke kraenke tredjepartsrettigheder. Du garanterer, at du har fulde og mangelfrie immaterielle rettigheder til sådant indhold eller har opnået lovlig tilladelse.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Tjenesterne genererer tilsvarende indhold baseret på dit input (herefter "genereret indhold"). Du bærer det fulde juridiske ansvar for genereret indhold, herunder, men ikke begrænset til, indholdets lovlighed, kraenkelse af immaterielle rettigheder, kraenkelse af personlige rettigheder og kommercielle risici. Du skal selv gennemgå, vurdere og om nødvendigt ændre det genererede indhold for at sikre, at det ikke overtraeder denne politik, hovedaftalen eller gældende love og regler.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Ansvar for offentliggørelse på tredjepartsplatforme',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Hvis du offentliggør genereret indhold på tredjepartsplatforme (såsom sociale medier, annoncesystemer, e-handelsplatforme osv.), skal du overholde disse platformes regler. Eventuelle sanktioner, tab eller retstvister, der opstår som følge af sådan offentliggørelse, bæres udelukkende af dig og har ingen forbindelse til denne platform.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Særlig påmindelse',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'AI-genereret indhold kan være underlagt tekniske begrænsninger såsom træningsdata og algoritmisk logik, og det garanteres ikke at være fuldstændigt præcist, uskadeligt eller i overensstemmelse med specifikke juridiske krav. Du må ikke påberåbe dig, at indholdet er "AI-genereret", for at fritage dig selv for juridisk ansvar.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Vores rettigheder til tilsyn og håndhævelse',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Vi har ret (men ikke pligt) til at føre tilsyn med, gennemgå eller kontrollere din brug af tjenesterne og det genererede indhold. Hvis vi opdager eller modtager en rimelig anmeldelse om, at du eller nogen, der bruger tjenesterne gennem din konto, har overtrådt denne politik, kan vi efter eget skøn træffe en eller flere af følgende foranstaltninger uden forudgående varsel:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Give dig en skriftlig advarsel og kræve afhjælpning inden for en fastsat frist;',
                            '2) Slette, blokere eller forbyde adgang til indhold, der overtræder reglerne;',
                            '3) Suspendere eller afslutte hele eller dele af din adgang til tjenesterne;',
                            '4) Lukke din konto permanent og forbyde dig at registrere dig igen;',
                            '5) Rapportere eller videregive dine kontooplysninger og brugsregistreringer til relevante retshåndhævende myndigheder, tilsynsmyndigheder eller rettighedshavere;',
                            '6) Gøre dit ansvar gældende for kontraktbrud eller rettighedskrænkelse i overensstemmelse med loven, herunder, men ikke begrænset til, at kræve erstatning for alle tab, som vi og/eller tredjeparter lider som følge heraf (herunder, men ikke begrænset til, retsomkostninger, advokatsalærer, erstatningsbeløb osv.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Ovenstående foranstaltninger påvirker ikke andre rettigheder, som vi måtte gøre gældende i henhold til hovedaftalen eller andre relaterede aftaler.',
                    },
                ],
            },
            {
                title: '4. Kanaler for rapportering og klager',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Hvis du under brugen af tjenesterne opdager, at en bruger eller noget indhold muligvis overtræder denne politik (for eksempel pornografisk indhold, krænkende indhold eller andre overtrædelser), opfordrer vi dig til at rapportere det eller indsende en klage til os via en af følgende metoder:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) E-mail: {email}',
                            '2) Online kundeservice: Log ind på din WeryAI-konto, gå til faktureringssiden eller hjælpecentret, klik på kundeservicefunktionen, og indsend de relevante oplysninger',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Vi vil gennemgå det rapporterede indhold inden for rimelig tid og træffe passende foranstaltninger i overensstemmelse med denne politik og gældende love og regler. Bemærk venligst, at vi muligvis ikke kan give et individuelt svar på hver rapport, men vi forpligter os til at tage hver gyldig rapport alvorligt.',
                    },
                ],
            },
            {
                title: '5. Opdateringer og ændringer af denne politik',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Vi kan fra tid til anden revidere eller opdatere denne politik baseret på forretningsudvikling, teknologiske ændringer, juridiske og regulatoriske krav eller ændringer i branchens bedste praksis. Den opdaterede politik vil blive meddelt dig via en eller flere af følgende metoder:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Offentliggørelse af en meddelelse på WeryAIs officielle hjemmeside (https://weryai.com);',
                            '2) Afsendelse af en meddelelse til din registrerede e-mailadresse;',
                            '3) Information via interne beskeder på siden, pop op-vinduer eller andre metoder.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Den reviderede politik træder i kraft på den ikrafttrædelsesdato, der er angivet i meddelelsen. Hvis du fortsætter med at bruge tjenesterne, betyder det, at du accepterer og indvilliger i at overholde den opdaterede politik; hvis du ikke accepterer opdateringen, skal du ophøre med at bruge tjenesterne.',
                    },
                ],
            },
        ],
        seoDescription:
            'WeryAIs politik for acceptabel brug, der beskriver forbudt indhold og adfærd, brugeransvar, tilsyn og håndhævelse, rapporteringskanaler og opdateringer af politikken.',
    },
    no: {
        title: 'WeryAIs retningslinjer for akseptabel bruk',
        introTitle: 'Innledning',
        intro: [
            'Disse retningslinjene for akseptabel bruk (heretter kalt "disse retningslinjene") utgjør en integrert del av WeryAIs tjenesteavtale (heretter kalt "hovedavtalen"). Ved å få tilgang til eller bruke noen av tjenestene som tilbys av WeryAI (inkludert, men ikke begrenset til, nettversjonen, mobilapplikasjoner og tilknyttede funksjoner for KI-generering av innhold, heretter samlet kalt "tjenestene"), samtykker du (heretter kalt "brukeren" eller "du") i å overholde alle vilkårene i disse retningslinjene.',
            'Formålet med disse retningslinjene er uttrykkelig å forby bruk av tjenestene til å generere, laste opp, spre eller lagre innhold som er ulovlig, upassende eller skader andres lovlige rettigheter og interesser, spesielt pornografisk innhold, nakenhet, seksuelle hentydninger og annen atferd som bryter med offentlig orden, moral eller gjeldende lover og forskrifter. Hvis du ikke godtar disse retningslinjene, må du umiddelbart slutte å bruke tjenestene.',
        ],
        sections: [
            {
                title: '1. Forbudt innhold og atferd',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Ved bruk av tjenestene skal du ikke, alene eller sammen med andre, utføre noen av følgende handlinger, og du skal heller ikke hjelpe, oppmuntre eller få andre til å utføre slike handlinger:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Pornografisk innhold, nakenhet og seksuelle hentydninger',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Vi forbyr strengt bruk av tjenestene til ethvert formål knyttet til pornografi, uanstendighet, nakenhet eller seksuelle hentydninger, inkludert, men ikke begrenset til:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Generering eller spredning av pornografisk innhold: bruk av tjenestene til å generere, laste opp, dele, vise eller overføre innhold som inneholder eller antyder seksuelle handlinger, seksuell provokasjon, seksuelle hentydninger, uanstendig språk, pornografiske beskrivelser, blottlagte kjønnsorganer, pornografisk animasjon, pornografisk lyd, pornografisk video, pornografisk tekstproduksjon eller lignende innhold;',
                                    '2) Pornografisk interaksjon og rollespill: gjennomføring av pornografiske samtaler, pornografiske rollespill, beskrivelser av seksuelle fantasier, seksuelle invitasjoner eller enhver form for virtuell seksuell interaksjon gjennom tjenestene;',
                                    '3) Henvisning til pornografiske plattformer og ressurser: tilby, publisere, promotere eller lede tilgang til pornografiske nettsteder, pornografiske apper, lenker til pornografiske ressurser, pornografiske sosiale grupper eller andre plattformer med vokseninnhold;',
                                    '4) Kommersiell pornografisk bruk: bruke tjenestene til produksjon, handel, annonsering, trafikkstyring eller enhver form for kommersiell pornografisk aktivitet.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Ulovlig, krenkende og skadelig innhold',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Du må ikke bruke tjenestene til å generere, laste opp, lagre eller spre følgende innhold eller drive relatert atferd:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Innhold som bryter med lover og forskrifter: inkludert, men ikke begrenset til, innhold som setter nasjonal sikkerhet i fare, undergraver statsmakten, skader nasjonal enhet, oppfordrer til etnisk hat eller fremmer terrorisme, ekstremisme eller separatisme;',
                                    '2) Innhold som krenker andres lovlige rettigheter og interesser: inkludert, men ikke begrenset til, uautorisert bruk av materiale beskyttet av opphavsrett, varemerker, patenter eller andre immaterielle rettigheter, eller innhold som krenker rett til bilde, personvern, omdømme, navn, forretningshemmeligheter eller andre rettigheter;',
                                    '3) Voldelig, hatefullt eller diskriminerende innhold: innhold som angriper, fornærmer, truer, trakasserer, diskriminerer eller oppfordrer til vold mot grupper eller enkeltpersoner på grunnlag av rase, etnisitet, religion, kjønn, seksuell orientering, alder, fysisk eller mental tilstand, nasjonalitet, region eller andre kjennetegn;',
                                    '4) Falskt, bedragersk eller villedende innhold: inkludert, men ikke begrenset til, fremstilling av falske nyheter, identitetsforfalskning, bedrageri, phishing-angrep, publisering av falsk reklame eller villedende kommersiell informasjon;',
                                    '5) Teknisk misbruk: inkludert, men ikke begrenset til, opplasting av virus, skadelig kode eller trojanere, bruk av crawlere eller boter for å få masseadgang til tjenestene, utnyttelse av tekniske sårbarheter for å omgå tjenestebegrensninger, gjennomføring av denial-of-service-angrep eller annen atferd som forstyrrer den normale driften av tjenestene.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Ditt fulle ansvar for innhold du legger inn og innhold som genereres',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Du forstår og godtar at alt innhold du gir som input til tjenestene (inkludert, men ikke begrenset til, tekstinstruksjoner, parameterinnstillinger, referanseeksempler, opplastede bilder, videoer, lyd og designmaler osv.) må være lovlig, i samsvar med gjeldende regler og ikke krenke tredjeparts rettigheter. Du garanterer at du har fullstendige og ulastelige immaterielle rettigheter til slikt innhold, eller at du har innhentet lovlig tillatelse.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Tjenestene genererer tilsvarende innhold basert på dine innspill (heretter kalt "generert innhold"). Du bærer det fulle juridiske ansvaret for generert innhold, inkludert, men ikke begrenset til, innholdets lovlighet, krenkelse av immaterielle rettigheter, krenkelse av personlige rettigheter og kommersiell risiko. Du skal selv gjennomgå, vurdere og om nødvendig endre det genererte innholdet for å sikre at det ikke bryter med disse retningslinjene, hovedavtalen eller gjeldende lover og forskrifter.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Ansvar for publisering på tredjepartsplattformer',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Hvis du publiserer generert innhold på tredjepartsplattformer (som sosiale medier, annonsesystemer, e-handelsplattformer osv.), må du overholde reglene på disse plattformene. Eventuelle sanksjoner, tap eller juridiske tvister som oppstår som følge av slik publisering, bæres utelukkende av deg og har ingen sammenheng med denne plattformen.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Særlig påminnelse',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'KI-generert innhold kan være underlagt tekniske begrensninger som treningsdata og algoritmisk logikk, og det garanteres ikke å være fullstendig nøyaktig, ufarlig eller i samsvar med spesifikke juridiske krav. Du kan ikke påberope deg at innholdet er "KI-generert" for å frita deg selv for juridisk ansvar.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Våre rettigheter til tilsyn og håndheving',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Vi har rett (men ikke plikt) til å føre tilsyn med, gjennomgå eller kontrollere din bruk av tjenestene og det genererte innholdet. Hvis vi oppdager eller mottar en rimelig melding om at du, eller noen som bruker tjenestene gjennom din konto, har brutt disse retningslinjene, kan vi etter eget skjønn iverksette ett eller flere av følgende tiltak uten forhåndsvarsel:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Gi deg en skriftlig advarsel og kreve retting innen en fastsatt frist;',
                            '2) Slette, blokkere eller forby tilgang til innhold som bryter reglene;',
                            '3) Suspendere eller avslutte hele eller deler av din tilgang til tjenestene;',
                            '4) Stenge kontoen din permanent og forby deg å registrere deg på nytt;',
                            '5) Rapportere eller utlevere kontoinformasjon og brukslogger til relevante rettshåndhevende myndigheter, tilsynsmyndigheter eller rettighetshavere;',
                            '6) Gjøre gjeldende ditt ansvar for kontraktsbrudd eller rettighetskrenkelse i samsvar med loven, inkludert, men ikke begrenset til, å kreve at du erstatter alle tap som vi og/eller tredjeparter lider som følge av dette (inkludert, men ikke begrenset til, saksomkostninger, advokatsalær, erstatning osv.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Tiltakene ovenfor påvirker ikke andre rettigheter vi kan gjøre gjeldende i henhold til hovedavtalen eller andre relaterte avtaler.',
                    },
                ],
            },
            {
                title: '4. Kanaler for rapportering og klager',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Hvis du under bruk av tjenestene oppdager at en bruker eller noe innhold kan være i strid med disse retningslinjene (for eksempel pornografisk innhold, krenkende innhold eller andre brudd), oppfordrer vi deg til å rapportere det eller sende inn en klage til oss gjennom en av følgende metoder:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) E-post: {email}',
                            '2) Online kundeservice: Logg inn på WeryAI-kontoen din, gå til faktureringssiden eller hjelpesenteret, klikk på kundeservicefunksjonen og send inn relevant informasjon',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Vi vil gjennomgå det rapporterte innholdet innen rimelig tid og iverksette passende tiltak i samsvar med disse retningslinjene og gjeldende lover og forskrifter. Vær oppmerksom på at vi kanskje ikke kan svare individuelt på hver rapport, men vi forplikter oss til å ta hver gyldige rapport på alvor.',
                    },
                ],
            },
            {
                title: '5. Oppdateringer og endringer i disse retningslinjene',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Vi kan fra tid til annen revidere eller oppdatere disse retningslinjene basert på forretningsutvikling, teknologiske endringer, juridiske og regulatoriske krav eller endringer i beste praksis i bransjen. De oppdaterte retningslinjene vil bli meddelt deg gjennom en eller flere av følgende metoder:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Publisering av en kunngjøring på WeryAIs offisielle nettsted (https://weryai.com);',
                            '2) Sende varsel til din registrerte e-postadresse;',
                            '3) Informasjon gjennom meldinger på nettstedet, popup-vinduer eller andre metoder.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'De reviderte retningslinjene trer i kraft på ikrafttredelsesdatoen som er angitt i kunngjøringen. Hvis du fortsetter å bruke tjenestene, betyr det at du aksepterer og samtykker i å overholde de oppdaterte retningslinjene; hvis du ikke godtar oppdateringen, må du slutte å bruke tjenestene.',
                    },
                ],
            },
        ],
        seoDescription:
            'WeryAIs retningslinjer for akseptabel bruk som beskriver forbudt innhold og atferd, brukeransvar, tilsyn og håndheving, rapporteringskanaler og oppdateringer av retningslinjene.',
    },
    nl: {
        title: 'Beleid voor aanvaardbaar gebruik van WeryAI',
        introTitle: 'Inleiding',
        intro: [
            'Dit Beleid voor aanvaardbaar gebruik (hierna "dit Beleid") vormt een integraal onderdeel van de WeryAI-serviceovereenkomst (hierna de "Hoofdovereenkomst"). Door toegang te verkrijgen tot of gebruik te maken van diensten die door WeryAI worden geleverd (waaronder, maar niet beperkt tot, de webversie, mobiele applicaties en gerelateerde functies voor AI-gegenereerde inhoud, hierna gezamenlijk de "Diensten"), stemt u (hierna de "Gebruiker" of "u") ermee in alle bepalingen van dit Beleid na te leven.',
            'Dit Beleid is bedoeld om uitdrukkelijk te verbieden dat de Diensten worden gebruikt om illegale, ongepaste of de wettige rechten en belangen van anderen schendende inhoud te genereren, uploaden, verspreiden of op te slaan, in het bijzonder pornografische inhoud, naaktheid, seksuele toespelingen en ander gedrag dat in strijd is met de openbare orde, goede zeden of toepasselijke wet- en regelgeving. Als u dit Beleid niet accepteert, dient u onmiddellijk te stoppen met het gebruik van de Diensten.',
        ],
        sections: [
            {
                title: '1. Verboden inhoud en gedragingen',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Bij het gebruik van de Diensten mag u, noch alleen noch samen met anderen, geen van de volgende handelingen verrichten, en u mag anderen evenmin helpen, aanmoedigen of ertoe aanzetten om dit te doen:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Pornografische inhoud, naaktheid en seksuele toespelingen',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Wij verbieden strikt het gebruik van de Diensten voor enig doel dat verband houdt met pornografie, obsceniteit, naaktheid of seksuele toespelingen, waaronder, maar niet beperkt tot:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Het genereren of verspreiden van pornografische inhoud: het gebruiken van de Diensten om inhoud te genereren, uploaden, delen, tonen of verzenden die seksuele handelingen, seksuele provocatie, seksuele toespelingen, obscene taal, pornografische beschrijvingen, blootgestelde geslachtsdelen, pornografische animatie, pornografische audio, pornografische video, pornografische tekstcreatie of soortgelijke inhoud bevat of suggereert;',
                                    '2) Pornografische interactie en rollenspel: het voeren van pornografische chats, pornografisch rollenspel, beschrijvingen van seksuele fantasieën, seksuele uitnodigingen of enige vorm van virtuele seksuele interactie via de Diensten;',
                                    '3) Verwijzing naar pornografische platforms en bronnen: het aanbieden, publiceren, promoten of leiden naar pornografische websites, pornografische apps, links naar pornografische bronnen, pornografische sociale groepen of andere platforms met inhoud voor volwassenen;',
                                    '4) Commercieel pornografisch gebruik: het gebruiken van de Diensten voor de productie, handel, reclame, verkeerssturing of enige vorm van commerciële pornografische activiteit.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Illegale, inbreukmakende en schadelijke inhoud',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'U mag de Diensten niet gebruiken om de volgende inhoud te genereren, uploaden, op te slaan of te verspreiden, noch om gerelateerde handelingen te verrichten:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Inhoud die wet- en regelgeving schendt: waaronder, maar niet beperkt tot, inhoud die de nationale veiligheid in gevaar brengt, de staatsmacht ondermijnt, de nationale eenheid schaadt, etnische haat aanwakkert of terrorisme, extremisme of separatisme propageert;',
                                    '2) Inhoud die de wettige rechten en belangen van anderen schendt: waaronder, maar niet beperkt tot, ongeoorloofd gebruik van materiaal dat wordt beschermd door auteursrechten, merken, patenten of andere intellectuele eigendomsrechten, of inhoud die beeldrechten, privacyrechten, reputatierechten, naamrechten, handelsgeheimen of andere rechten schendt;',
                                    '3) Gewelddadige, haatdragende of discriminerende inhoud: inhoud die groepen of individuen aanvalt, beledigt, bedreigt, lastigvalt, discrimineert of aanzet tot geweld op grond van ras, etniciteit, religie, geslacht, seksuele geaardheid, leeftijd, lichamelijke of geestelijke toestand, nationaliteit, regio of andere kenmerken;',
                                    '4) Valse, frauduleuze of misleidende inhoud: waaronder, maar niet beperkt tot, het creëren van nepnieuws, identiteitsvervalsing, het plegen van fraude, phishing-aanvallen, het publiceren van valse reclame of misleidende commerciële informatie;',
                                    '5) Technisch misbruik: waaronder, maar niet beperkt tot, het uploaden van virussen, kwaadaardige code of Trojaanse paarden, het gebruik van crawlers of bots voor massale toegang tot de Diensten, het uitbuiten van technische kwetsbaarheden om dienstbeperkingen te omzeilen, het uitvoeren van denial-of-service-aanvallen of ander gedrag dat de normale werking van de Diensten verstoort.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Uw volledige verantwoordelijkheid voor ingevoerde inhoud en gegenereerde inhoud',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'U begrijpt en stemt ermee in dat alle invoerinformatie die u aan de Diensten verstrekt (waaronder, maar niet beperkt tot, tekstprompts, parameterinstellingen, referentievoorbeelden, geüploade afbeeldingen, video’s, audio en ontwerpsjablonen enz.) wettig, conform de regels en vrij van schending van rechten van derden moet zijn. U garandeert dat u volledige en onbezwaarde intellectuele eigendomsrechten op dergelijke inhoud bezit, of dat u daarvoor rechtsgeldige toestemming hebt verkregen.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'De Diensten genereren overeenkomstige inhoud op basis van uw invoer (hierna "Gegenereerde inhoud"). U draagt de volledige juridische verantwoordelijkheid voor de Gegenereerde inhoud, waaronder, maar niet beperkt tot, de rechtmatigheid van de inhoud, inbreuk op intellectuele eigendomsrechten, schending van persoonlijkheidsrechten en commerciële risico’s. U dient de Gegenereerde inhoud zelfstandig te controleren, te beoordelen en indien nodig te wijzigen om ervoor te zorgen dat deze niet in strijd is met dit Beleid, de Hoofdovereenkomst of toepasselijke wet- en regelgeving.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Verantwoordelijkheid voor publicatie op platforms van derden',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Als u Gegenereerde inhoud publiceert op platforms van derden (zoals sociale media, advertentiesystemen, e-commerceplatforms enz.), moet u zich houden aan de regels van die platforms. Eventuele sancties, verliezen of juridische geschillen die voortvloeien uit dergelijke publicatie komen uitsluitend voor uw rekening en houden geen verband met dit platform.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Bijzondere herinnering',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Door AI gegenereerde inhoud kan onderhevig zijn aan technische beperkingen, zoals trainingsgegevens en algoritmische logica, en wordt niet gegarandeerd als volledig nauwkeurig, onschadelijk of in overeenstemming met specifieke wettelijke vereisten. U mag zich er niet op beroepen dat inhoud "door AI is gegenereerd" om uzelf van juridische verantwoordelijkheid te ontheffen.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Onze rechten op toezicht en handhaving',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Wij hebben het recht (maar niet de verplichting) om toezicht te houden op, te beoordelen of steekproefsgewijs te controleren hoe u de Diensten gebruikt en welke Gegenereerde inhoud daarbij ontstaat. Indien wij ontdekken of een redelijke melding ontvangen dat u, of iemand die de Diensten via uw account gebruikt, dit Beleid heeft overtreden, kunnen wij naar eigen goeddunken zonder voorafgaande kennisgeving een of meer van de volgende maatregelen nemen:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) U een schriftelijke waarschuwing geven en herstel binnen een bepaalde termijn eisen;',
                            '2) In strijd zijnde inhoud verwijderen, blokkeren of de toegang daartoe verbieden;',
                            '3) Uw toegang tot de Diensten geheel of gedeeltelijk opschorten of beëindigen;',
                            '4) Uw account permanent sluiten en u verbieden zich opnieuw te registreren;',
                            '5) Uw accountinformatie en gebruiksgegevens melden of openbaar maken aan relevante rechtshandhavingsinstanties, toezichthouders of rechthebbenden;',
                            '6) U aansprakelijk stellen voor contractbreuk of schending van rechten overeenkomstig de wet, met inbegrip van, maar niet beperkt tot, het eisen dat u alle verliezen vergoedt die wij en/of derden daardoor lijden (waaronder, maar niet beperkt tot, proceskosten, advocaatkosten, schadevergoedingen enz.).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'De bovenstaande maatregelen doen geen afbreuk aan andere rechten die wij op grond van de Hoofdovereenkomst of andere gerelateerde overeenkomsten kunnen doen gelden.',
                    },
                ],
            },
            {
                title: '4. Kanalen voor meldingen en klachten',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Als u tijdens het gebruik van de Diensten ontdekt dat een gebruiker of inhoud mogelijk in strijd is met dit Beleid (bijvoorbeeld pornografische inhoud, inbreukmakende inhoud of andere overtredingen), moedigen wij u aan dit aan ons te melden of een klacht in te dienen via een van de volgende methoden:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) E-mail: {email}',
                            '2) Online klantenservice: Log in op uw WeryAI-account, ga naar de factureringspagina of het helpcentrum, klik op de klantenservicefunctie en dien de relevante informatie in',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Wij zullen de gemelde inhoud binnen een redelijke termijn beoordelen en passende maatregelen nemen in overeenstemming met dit Beleid en toepasselijke wet- en regelgeving. Houd er rekening mee dat wij mogelijk niet op elke melding individueel kunnen reageren, maar wij verbinden ons ertoe elke geldige melding serieus te behandelen.',
                    },
                ],
            },
            {
                title: '5. Updates en wijzigingen van dit Beleid',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Wij kunnen dit Beleid van tijd tot tijd herzien of bijwerken op basis van bedrijfsontwikkeling, technologische veranderingen, wettelijke en regelgevende vereisten of wijzigingen in best practices binnen de sector. Het bijgewerkte Beleid zal u via een of meer van de volgende methoden worden meegedeeld:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Publicatie van een aankondiging op de officiële website van WeryAI (https://weryai.com);',
                            '2) Het verzenden van een kennisgeving naar uw geregistreerde e-mailadres;',
                            '3) Kennisgeving via berichten op de website, pop-upvensters of andere methoden.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Het herziene Beleid treedt in werking op de ingangsdatum die in de aankondiging wordt vermeld. Als u de Diensten blijft gebruiken, betekent dit dat u het bijgewerkte Beleid accepteert en ermee instemt dit na te leven; als u de update niet accepteert, dient u te stoppen met het gebruik van de Diensten.',
                    },
                ],
            },
        ],
        seoDescription:
            'Beleid voor aanvaardbaar gebruik van WeryAI waarin verboden inhoud en gedragingen, gebruikersverantwoordelijkheid, toezicht en handhaving, meldingskanalen en beleidsupdates worden beschreven.',
    },
    id: {
        title: 'Kebijakan Penggunaan yang Dapat Diterima WeryAI',
        introTitle: 'Pendahuluan',
        intro: [
            'Kebijakan Penggunaan yang Dapat Diterima ini (selanjutnya disebut "Kebijakan ini") merupakan bagian yang tidak terpisahkan dari Perjanjian Layanan WeryAI (selanjutnya disebut "Perjanjian Utama"). Dengan mengakses atau menggunakan layanan apa pun yang disediakan oleh WeryAI (termasuk namun tidak terbatas pada versi web, aplikasi seluler, dan fitur terkait pembuatan konten berbasis kecerdasan buatan, yang selanjutnya secara bersama-sama disebut "Layanan"), Anda (selanjutnya disebut "Pengguna" atau "Anda") setuju untuk mematuhi seluruh ketentuan dalam Kebijakan ini.',
            'Kebijakan ini bertujuan untuk secara tegas melarang penggunaan Layanan untuk menghasilkan, mengunggah, menyebarluaskan, atau menyimpan konten apa pun yang ilegal, tidak pantas, atau merugikan hak dan kepentingan sah pihak lain, khususnya konten pornografi, ketelanjangan, isyarat seksual, dan perilaku lain yang melanggar ketertiban umum, kesusilaan, atau hukum dan peraturan yang berlaku. Jika Anda tidak menerima Kebijakan ini, harap segera berhenti menggunakan Layanan.',
        ],
        sections: [
            {
                title: '1. Konten dan perilaku yang dilarang',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Saat menggunakan Layanan, Anda tidak boleh, baik sendiri maupun bersama orang lain, melakukan salah satu tindakan berikut, dan Anda juga tidak boleh membantu, mendorong, atau menghasut orang lain untuk melakukannya:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Konten pornografi, ketelanjangan, dan isyarat seksual',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Kami secara tegas melarang penggunaan Layanan untuk tujuan apa pun yang berkaitan dengan pornografi, kecabulan, ketelanjangan, atau isyarat seksual, termasuk namun tidak terbatas pada:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Menghasilkan atau menyebarkan konten pornografi: menggunakan Layanan untuk menghasilkan, mengunggah, membagikan, menampilkan, atau mengirimkan konten apa pun yang memuat atau menyiratkan tindakan seksual, provokasi seksual, isyarat seksual, bahasa cabul, deskripsi pornografi, organ seksual yang terekspos, animasi pornografi, audio pornografi, video pornografi, pembuatan teks pornografi, atau konten serupa;',
                                    '2) Interaksi pornografis dan permainan peran: melakukan percakapan pornografis, permainan peran pornografis, deskripsi fantasi seksual, ajakan seksual, atau segala bentuk interaksi seksual virtual melalui Layanan;',
                                    '3) Pengarahan ke platform dan sumber pornografi: menyediakan, menerbitkan, mempromosikan, atau mengarahkan akses ke situs pornografi, aplikasi pornografi, tautan ke sumber pornografi, kelompok sosial pornografi, atau platform konten dewasa lainnya;',
                                    '4) Penggunaan pornografis untuk tujuan komersial: menggunakan Layanan untuk produksi, perdagangan, periklanan, pengalihan lalu lintas, atau segala bentuk kegiatan pornografi komersial.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Konten ilegal, melanggar hak, dan berbahaya',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Anda tidak boleh menggunakan Layanan untuk menghasilkan, mengunggah, menyimpan, atau menyebarluaskan konten berikut atau melakukan perilaku terkait:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Konten yang melanggar hukum dan peraturan: termasuk namun tidak terbatas pada konten yang membahayakan keamanan nasional, menggulingkan kekuasaan negara, merusak persatuan nasional, menghasut kebencian etnis, atau mempromosikan terorisme, ekstremisme, atau separatisme;',
                                    '2) Konten yang melanggar hak dan kepentingan sah pihak lain: termasuk namun tidak terbatas pada penggunaan tanpa izin atas materi yang dilindungi hak cipta, merek dagang, paten, atau hak kekayaan intelektual lainnya, atau konten yang melanggar hak citra, privasi, reputasi, nama, rahasia dagang, atau hak lainnya;',
                                    '3) Konten kekerasan, kebencian, atau diskriminatif: konten yang menyerang, menghina, mengancam, melecehkan, mendiskriminasi, atau menghasut kekerasan terhadap kelompok atau individu berdasarkan ras, etnis, agama, gender, orientasi seksual, usia, kondisi fisik atau mental, kewarganegaraan, wilayah, atau karakteristik lainnya;',
                                    '4) Konten palsu, curang, atau menyesatkan: termasuk namun tidak terbatas pada pembuatan berita palsu, pemalsuan identitas, pelaksanaan penipuan, serangan phishing, penerbitan iklan palsu, atau informasi komersial yang menyesatkan;',
                                    '5) Penyalahgunaan teknis: termasuk namun tidak terbatas pada pengunggahan virus, kode berbahaya, atau trojan, penggunaan crawler atau bot untuk mengakses Layanan secara massal, mengeksploitasi celah teknis untuk melewati pembatasan layanan, melakukan serangan denial-of-service, atau perilaku lain yang merusak operasi normal Layanan.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Tanggung jawab penuh Anda atas konten masukan dan konten yang dihasilkan',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Anda memahami dan menyetujui bahwa seluruh konten masukan yang Anda berikan kepada Layanan (termasuk namun tidak terbatas pada perintah teks, pengaturan parameter, kasus referensi, gambar, video, audio, dan templat desain yang diunggah, dan sebagainya) harus sah, sesuai ketentuan, dan tidak melanggar hak pihak ketiga mana pun. Anda menjamin bahwa Anda memiliki hak kekayaan intelektual yang lengkap dan bebas cacat atas konten tersebut atau telah memperoleh otorisasi yang sah.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Layanan menghasilkan konten yang sesuai berdasarkan masukan Anda (selanjutnya disebut "Konten yang Dihasilkan"). Anda memikul tanggung jawab hukum penuh atas Konten yang Dihasilkan, termasuk namun tidak terbatas pada kesesuaian konten, pelanggaran kekayaan intelektual, pelanggaran hak kepribadian, dan risiko komersial. Anda harus meninjau, mengevaluasi, dan memodifikasi sendiri Konten yang Dihasilkan jika diperlukan untuk memastikan bahwa konten tersebut tidak melanggar Kebijakan ini, Perjanjian Utama, atau hukum dan peraturan yang berlaku.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Tanggung jawab atas publikasi di platform pihak ketiga',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Jika Anda mempublikasikan Konten yang Dihasilkan di platform pihak ketiga (seperti media sosial, sistem periklanan, platform e-commerce, dan sebagainya), Anda harus mematuhi aturan platform tersebut. Setiap sanksi, kerugian, atau sengketa hukum yang timbul dari publikasi tersebut sepenuhnya menjadi tanggung jawab Anda dan tidak ada kaitannya dengan platform ini.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Pengingat khusus',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Konten yang dihasilkan AI dapat tunduk pada keterbatasan teknis seperti data pelatihan dan logika algoritmik, dan tidak dijamin sepenuhnya akurat, tidak berbahaya, atau sesuai dengan persyaratan hukum tertentu. Anda tidak boleh beralasan bahwa konten tersebut "dihasilkan oleh AI" untuk membebaskan diri dari tanggung jawab hukum Anda sendiri.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Hak kami untuk pengawasan dan penegakan',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Kami memiliki hak (tetapi bukan kewajiban) untuk mengawasi, meninjau, atau memeriksa penggunaan Layanan dan Konten yang Dihasilkan oleh Anda. Jika kami menemukan atau menerima laporan yang wajar bahwa Anda, atau siapa pun yang menggunakan Layanan melalui akun Anda, telah melanggar Kebijakan ini, kami dapat, atas kebijakan kami sendiri, mengambil satu atau lebih tindakan berikut tanpa pemberitahuan sebelumnya:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Mengeluarkan peringatan tertulis kepada Anda dan mewajibkan perbaikan dalam jangka waktu tertentu;',
                            '2) Menghapus, memblokir, atau melarang akses ke konten yang melanggar;',
                            '3) Menangguhkan atau menghentikan seluruh atau sebagian akses Anda ke Layanan;',
                            '4) Menutup akun Anda secara permanen dan melarang Anda mendaftar ulang;',
                            '5) Melaporkan atau mengungkapkan informasi akun dan catatan penggunaan Anda kepada otoritas penegak hukum, badan pengawas, atau pemegang hak terkait;',
                            '6) Menuntut tanggung jawab Anda atas pelanggaran kontrak atau pelanggaran hak sesuai hukum, termasuk namun tidak terbatas pada mewajibkan Anda mengganti seluruh kerugian yang kami dan/atau pihak ketiga derita karenanya (termasuk namun tidak terbatas pada biaya litigasi, biaya pengacara, ganti rugi, dan sebagainya).',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Tindakan di atas tidak memengaruhi hak lain apa pun yang dapat kami tuntut berdasarkan Perjanjian Utama atau perjanjian terkait lainnya.',
                    },
                ],
            },
            {
                title: '4. Saluran pelaporan dan pengaduan',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Jika selama penggunaan Layanan Anda menemukan bahwa pengguna atau konten apa pun mungkin melanggar Kebijakan ini (misalnya konten pornografi, konten yang melanggar hak, atau pelanggaran lainnya), kami mendorong Anda untuk melaporkan atau mengajukan pengaduan kepada kami melalui salah satu cara berikut:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Email: {email}',
                            '2) Layanan pelanggan online: Masuk ke akun WeryAI Anda, buka halaman penagihan atau pusat bantuan, klik tombol layanan pelanggan, dan kirimkan informasi yang relevan',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Kami akan meninjau konten yang dilaporkan dalam jangka waktu yang wajar dan mengambil tindakan yang sesuai sesuai dengan Kebijakan ini dan hukum serta peraturan yang berlaku. Harap diperhatikan bahwa kami mungkin tidak dapat memberikan tanggapan individual atas setiap laporan, tetapi kami berkomitmen untuk menanggapi setiap laporan yang sah dengan serius.',
                    },
                ],
            },
            {
                title: '5. Pembaruan dan perubahan Kebijakan ini',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Kami dapat dari waktu ke waktu merevisi atau memperbarui Kebijakan ini berdasarkan perkembangan bisnis, perubahan teknologi, persyaratan hukum dan regulasi, atau perubahan praktik terbaik industri. Kebijakan yang diperbarui akan diberitahukan kepada Anda melalui satu atau lebih cara berikut:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Menerbitkan pengumuman di situs web resmi WeryAI (https://weryai.com);',
                            '2) Mengirimkan pemberitahuan ke alamat email terdaftar Anda;',
                            '3) Memberi tahu melalui pesan di dalam situs, jendela pop-up, atau cara lainnya.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Kebijakan yang direvisi akan berlaku pada tanggal efektif yang tercantum dalam pengumuman. Jika Anda terus menggunakan Layanan, hal itu berarti Anda menerima dan setuju untuk mematuhi Kebijakan yang diperbarui; jika Anda tidak menerima pembaruan, harap berhenti menggunakan Layanan.',
                    },
                ],
            },
        ],
        seoDescription:
            'Kebijakan Penggunaan yang Dapat Diterima WeryAI yang menjelaskan konten dan perilaku yang dilarang, tanggung jawab pengguna, pengawasan dan penegakan, saluran pelaporan, serta pembaruan kebijakan.',
    },
    tr: {
        title: 'WeryAI Kabul Edilebilir Kullanım Politikası',
        introTitle: 'Giriş',
        intro: [
            'Bu Kabul Edilebilir Kullanım Politikası (bundan sonra "bu Politika" olarak anılacaktır), WeryAI Hizmet Sözleşmesinin (bundan sonra "Ana Sözleşme" olarak anılacaktır) ayrılmaz bir parçasını oluşturur. WeryAI tarafından sunulan herhangi bir hizmete erişerek veya bu hizmetleri kullanarak (web sürümü, mobil uygulamalar ve ilgili yapay zeka içerik oluşturma işlevleri dahil ancak bunlarla sınırlı olmamak üzere, bundan sonra topluca "Hizmetler" olarak anılacaktır), siz (bundan sonra "Kullanıcı" veya "siz" olarak anılacaktır) bu Politikanın tüm şartlarına uymayı kabul etmiş olursunuz.',
            'Bu Politikanın amacı, Hizmetlerin yasa dışı, uygunsuz veya başkalarının meşru hak ve menfaatlerine zarar veren herhangi bir içeriği üretmek, yüklemek, yaymak veya depolamak için kullanılmasını açıkça yasaklamaktır; özellikle pornografik içerik, çıplaklık, cinsel imalar ve kamu düzenine, genel ahlaka veya yürürlükteki yasa ve düzenlemelere aykırı diğer davranışlar buna dahildir. Bu Politikayı kabul etmiyorsanız, lütfen Hizmetleri kullanmayı derhal bırakın.',
        ],
        sections: [
            {
                title: '1. Yasaklı içerik ve davranışlar',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Hizmetleri kullanırken, tek başınıza veya başkalarıyla birlikte aşağıdaki eylemlerden hiçbirini gerçekleştiremezsiniz; ayrıca başkalarının bu eylemleri gerçekleştirmesine yardımcı olamaz, onları teşvik edemez veya buna yönlendiremezsiniz:',
                    },
                ],
                subsections: [
                    {
                        title: '1.1 Pornografik içerik, çıplaklık ve cinsel imalar',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Hizmetlerin pornografi, müstehcenlik, çıplaklık veya cinsel imalarla ilgili herhangi bir amaç için kullanılmasını kesin olarak yasaklıyoruz; buna aşağıdakiler dahil olmakla birlikte bunlarla sınırlı değildir:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Pornografik içerik üretmek veya yaymak: Hizmetleri, cinsel eylemler, cinsel tahrik, cinsel imalar, müstehcen dil, pornografik tasvirler, açıkta kalan cinsel organlar, pornografik animasyon, pornografik ses, pornografik video, pornografik metin oluşturma veya benzeri içerikleri içeren ya da ima eden herhangi bir içeriği üretmek, yüklemek, paylaşmak, göstermek veya iletmek için kullanmak;',
                                    '2) Pornografik etkileşim ve rol yapma: Hizmetler aracılığıyla pornografik sohbetler, pornografik rol yapma, cinsel fantezi açıklamaları, cinsel davetler veya her türlü sanal cinsel etkileşimi yürütmek;',
                                    '3) Pornografik platformlara ve kaynaklara yönlendirme: pornografik web sitelerine, pornografik uygulamalara, pornografik kaynak bağlantılarına, pornografik sosyal gruplara veya diğer yetişkin içerik platformlarına erişimi sağlamak, yayınlamak, tanıtmak veya yönlendirmek;',
                                    '4) Ticari pornografik kullanım: Hizmetleri pornografik içerik üretimi, ticareti, reklamı, trafik yönlendirmesi veya herhangi bir biçimde ticari pornografik faaliyet için kullanmak.',
                                ],
                            },
                        ],
                    },
                    {
                        title: '1.2 Yasa dışı, hak ihlal eden ve zararlı içerik',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Aşağıdaki içerikleri üretmek, yüklemek, depolamak veya yaymak ya da buna ilişkin davranışlarda bulunmak için Hizmetleri kullanamazsınız:',
                            },
                            {
                                type: 'list',
                                items: [
                                    '1) Yasa ve düzenlemeleri ihlal eden içerik: ulusal güvenliği tehlikeye atan, devlet iktidarını yıkmaya yönelik, ulusal birliği bozan, etnik nefreti körükleyen veya terörizmi, aşırıcılığı ya da ayrılıkçılığı teşvik eden içerikler dahil ancak bunlarla sınırlı olmamak üzere;',
                                    '2) Başkalarının meşru hak ve menfaatlerini ihlal eden içerik: telif hakkı, ticari marka, patent veya diğer fikri mülkiyet haklarıyla korunan materyallerin izinsiz kullanımı ya da görüntü hakkı, gizlilik hakkı, itibar hakkı, isim hakkı, ticari sırlar veya diğer hakları ihlal eden içerikler dahil ancak bunlarla sınırlı olmamak üzere;',
                                    '3) Şiddet, nefret veya ayrımcı içerik: ırk, etnik köken, din, cinsiyet, cinsel yönelim, yaş, fiziksel veya zihinsel durum, uyruk, bölge veya diğer özelliklere dayalı olarak gruplara veya bireylere saldıran, hakaret eden, tehdit eden, taciz eden, ayrımcılık yapan veya şiddete teşvik eden içerik;',
                                    '4) Yanlış, dolandırıcı veya yanıltıcı içerik: sahte haber üretimi, kimlik sahteciliği, dolandırıcılık gerçekleştirilmesi, kimlik avı saldırıları, sahte reklam veya yanıltıcı ticari bilgi yayımlanması dahil ancak bunlarla sınırlı olmamak üzere;',
                                    '5) Teknik kötüye kullanım: virüs, kötü amaçlı kod veya Truva atı yüklemek, Hizmetlere toplu erişim sağlamak için tarayıcılar veya botlar kullanmak, hizmet kısıtlamalarını aşmak için teknik açıkları istismar etmek, hizmet reddi saldırıları gerçekleştirmek veya Hizmetlerin normal çalışmasını bozan diğer davranışlar dahil ancak bunlarla sınırlı olmamak üzere.',
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                title: '2. Girdi içeriği ve üretilen içerik için tüm sorumluluğunuz',
                subsections: [
                    {
                        title: '2.1',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Hizmetlere sağladığınız tüm girdi içeriklerinin (metin komutları, parametre ayarları, referans örnekleri, yüklenen görseller, videolar, sesler ve tasarım şablonları dahil ancak bunlarla sınırlı olmamak üzere) yasal, kurallara uygun ve üçüncü tarafların haklarını ihlal etmeyen nitelikte olması gerektiğini anlıyor ve kabul ediyorsunuz. Bu içerikler üzerinde eksiksiz ve kusursuz fikri mülkiyet haklarına sahip olduğunuzu veya yasal yetki aldığınızı garanti edersiniz.',
                            },
                        ],
                    },
                    {
                        title: '2.2',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Hizmetler, girdilerinize dayanarak ilgili içeriği üretir (bundan sonra "Üretilen İçerik" olarak anılacaktır). İçeriğin uygunluğu, fikri mülkiyet ihlali, kişilik haklarının ihlali ve ticari riskler dahil ancak bunlarla sınırlı olmamak üzere Üretilen İçerik ile ilgili tüm hukuki sorumluluk size aittir. Üretilen İçeriğin bu Politikayı, Ana Sözleşmeyi veya yürürlükteki herhangi bir yasa ve düzenlemeyi ihlal etmediğinden emin olmak için gerekli inceleme, değerlendirme ve değişiklikleri kendiniz yapmalısınız.',
                            },
                        ],
                    },
                    {
                        title: '2.3 Üçüncü taraf platformlarda yayımlama sorumluluğu',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Üretilen İçeriği üçüncü taraf platformlarda (sosyal medya, reklam sistemleri, e-ticaret platformları vb.) yayımlarsanız, bu platformların kurallarına uymanız gerekir. Bu tür yayımdan doğan her türlü yaptırım, kayıp veya hukuki uyuşmazlık tamamen sizin sorumluluğunuzdadır ve bu platformla hiçbir ilgisi yoktur.',
                            },
                        ],
                    },
                    {
                        title: '2.4 Özel hatırlatma',
                        blocks: [
                            {
                                type: 'paragraph',
                                text: 'Yapay zeka tarafından üretilen içerik, eğitim verileri ve algoritmik mantık gibi teknik sınırlamalara tabi olabilir ve mutlak olarak doğru, zararsız veya belirli yasal gerekliliklere uygun olduğu garanti edilmez. İçeriğin "yapay zeka tarafından üretildiği" gerekçesiyle kendi hukuki sorumluluğunuzdan kaçınamazsınız.',
                            },
                        ],
                    },
                ],
            },
            {
                title: '3. Gözetim ve yaptırım haklarımız',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Hizmetleri kullanımınızı ve Üretilen İçeriği denetleme, inceleme veya kontrol etme hakkına sahibiz (ancak bu bizim yükümlülüğümüz değildir). Sizin veya hesabınız aracılığıyla Hizmetleri kullanan herhangi bir kişinin bu Politikayı ihlal ettiğini tespit edersek veya buna ilişkin makul bir bildirim alırsak, tamamen kendi takdirimize bağlı olarak aşağıdaki önlemlerden birini veya birkaçını önceden bildirimde bulunmaksızın alabiliriz:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) Size yazılı uyarı vermek ve belirli bir süre içinde düzeltme talep etmek;',
                            '2) İhlal niteliğindeki içeriği silmek, engellemek veya erişimi yasaklamak;',
                            '3) Hizmetlere erişiminizin tamamını veya bir kısmını askıya almak veya sonlandırmak;',
                            '4) Hesabınızı kalıcı olarak kapatmak ve yeniden kayıt olmanızı yasaklamak;',
                            '5) Hesap bilgileriniz ve kullanım kayıtlarınızı ilgili kolluk kuvvetlerine, düzenleyici kurumlara veya hak sahiplerine bildirmek veya açıklamak;',
                            '6) Sözleşme ihlali veya hak ihlali nedeniyle yasal sorumluluğunuzu talep etmek; buna bizim ve/veya üçüncü tarafların bu nedenle uğradığı tüm zararları (dava giderleri, avukatlık ücretleri, tazminatlar vb. dahil ancak bunlarla sınırlı olmamak üzere) ödemenizi istemek de dahildir.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Yukarıdaki önlemler, Ana Sözleşme veya diğer ilgili sözleşmeler kapsamında ileri sürebileceğimiz diğer hakları etkilemez.',
                    },
                ],
            },
            {
                title: '4. Bildirim ve şikayet kanalları',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'Hizmetleri kullanırken herhangi bir kullanıcının veya herhangi bir içeriğin bu Politikayı ihlal edebileceğini fark ederseniz (örneğin pornografik içerik, hak ihlali içeren içerik veya diğer ihlaller), aşağıdaki yollarla bize bildirimde bulunmanızı veya şikayette bulunmanızı teşvik ederiz:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) E-posta: {email}',
                            '2) Çevrim içi müşteri hizmetleri: WeryAI hesabınıza giriş yapın, faturalandırma sayfasına veya yardım merkezine gidin, müşteri hizmetleri işlev düğmesine tıklayın ve ilgili bilgileri gönderin',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Bildirilen içeriği makul bir süre içinde inceleyecek ve bu Politika ile yürürlükteki yasa ve düzenlemelere uygun olarak gerekli önlemleri alacağız. Her bildirime ayrı ayrı yanıt veremeyebileceğimizi lütfen unutmayın; ancak her geçerli bildirimi ciddiyetle ele almayı taahhüt ediyoruz.',
                    },
                ],
            },
            {
                title: '5. Bu Politikanın güncellenmesi ve değiştirilmesi',
                blocks: [
                    {
                        type: 'paragraph',
                        text: 'İş gelişmeleri, teknolojik değişiklikler, yasal ve düzenleyici gereklilikler veya sektörün en iyi uygulamalarındaki değişikliklere bağlı olarak bu Politikayı zaman zaman gözden geçirebilir veya güncelleyebiliriz. Güncellenen Politika, aşağıdaki yöntemlerden biri veya birkaçı ile size bildirilecektir:',
                    },
                    {
                        type: 'list',
                        items: [
                            '1) WeryAI’nin resmi web sitesinde (https://weryai.com) duyuru yayımlanması;',
                            '2) Kayıtlı e-posta adresinize bildirim gönderilmesi;',
                            '3) Site içi mesajlar, açılır pencereler veya diğer yollarla bilgilendirme yapılması.',
                        ],
                    },
                    {
                        type: 'paragraph',
                        text: 'Gözden geçirilmiş Politika, duyuruda belirtilen yürürlük tarihinden itibaren geçerli olur. Hizmetleri kullanmaya devam etmeniz, güncellenmiş Politikayı kabul ettiğiniz ve buna uymayı kabul ettiğiniz anlamına gelir; güncellemeyi kabul etmiyorsanız, lütfen Hizmetleri kullanmayı bırakın.',
                    },
                ],
            },
        ],
        seoDescription:
            'WeryAI Kabul Edilebilir Kullanım Politikası; yasaklı içerik ve davranışları, kullanıcı sorumluluğunu, gözetim ve yaptırımı, bildirim kanallarını ve politika güncellemelerini açıklar.',
    },
}
